{
  "schemaVersion": 2,
  "id": "profile-add",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "stageScaleBase": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; slicePx is original PNG pixels",
  "sourceRoot": "repository root",
  "reference": "var/out/profile-today.png",
  "chipReference": "var/out/chip-text.png",
  "defaultState": "empty",
  "defaultExample": "empty",
  "reviewStatus": "Design proof, not owner approval or application implementation.",
  "pieces": {
    "profile.frame": {
      "path": "apps/client/public/art/ui4/panel-meetflirt@2x.png",
      "pixelW": 1720,
      "pixelH": 600,
      "alpha": true,
      "sha256": "a78997bf81961e14a3bf536a750db7249899b78cdd86a8a6454a26eb5299af52",
      "reused": true,
      "slicePx": {
        "top": 112,
        "right": 112,
        "bottom": 112,
        "left": 112
      },
      "borderWidth": 56
    },
    "pill.off": {
      "path": "apps/client/public/art/create-kit/pill.off.png",
      "pixelW": 247,
      "pixelH": 140,
      "alpha": true,
      "sha256": "4e4c0d8bfeb8c1fcaabb2a0cb9f02c3979a9a723a189da8df7ebaab469d32cb2",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      }
    },
    "pill.on": {
      "path": "apps/client/public/art/create-kit/pill.on.png",
      "pixelW": 247,
      "pixelH": 140,
      "alpha": true,
      "sha256": "fe020c119da9e66c9acf92c0da5a3d57bab8f6a617716ee20eb5a7d6dbcdc0b3",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      }
    },
    "field": {
      "path": "apps/client/public/art/ui/field-v1@2x.png",
      "pixelW": 1690,
      "pixelH": 216,
      "alpha": true,
      "sha256": "692123893a254f7d4444d0dfd88bc4ce7470b2620018bdc391cff88814cefa35",
      "reused": true,
      "slicePx": {
        "top": 56,
        "right": 112,
        "bottom": 56,
        "left": 112
      },
      "borderWidth": {
        "top": 28,
        "right": 56,
        "bottom": 28,
        "left": 56
      }
    },
    "field.focus": {
      "path": "apps/client/public/art/ui/field-focus-v1@2x.png",
      "pixelW": 1690,
      "pixelH": 216,
      "alpha": true,
      "sha256": "531b9d66fa737a3fad5d156594676316acaf0e73bebabb9b4fbb69c1901d1227",
      "reused": true,
      "slicePx": {
        "top": 56,
        "right": 112,
        "bottom": 56,
        "left": 112
      },
      "borderWidth": {
        "top": 28,
        "right": 56,
        "bottom": 28,
        "left": 56
      }
    },
    "chevron": {
      "path": "apps/client/public/art/profile-cut/slice/date-chevron.png",
      "pixelW": 39,
      "pixelH": 39,
      "alpha": true,
      "sha256": "bb4c6fc9265820b9ad4e3a9aca8aa633da68de8b2804c8093063e6782bcab7e1",
      "reused": true
    },
    "country.panel": {
      "path": "apps/client/public/art/lang-cut/panel.png",
      "pixelW": 838,
      "pixelH": 984,
      "alpha": true,
      "sha256": "1cde90ce90a72969f47c04470373aa9854efbeb2c7f6eaf6cac24fe7de871933",
      "reused": true,
      "slicePx": {
        "top": 170,
        "right": 170,
        "bottom": 170,
        "left": 80
      },
      "borderWidth": {
        "top": 170,
        "right": 170,
        "bottom": 170,
        "left": 80
      }
    },
    "country.row.off": {
      "path": "apps/client/public/art/lang-cut/row.es.png",
      "pixelW": 378,
      "pixelH": 114,
      "alpha": true,
      "sha256": "17c22dd19613f974c8ecb0dc823f33ea6ed3a2024dcc8d630437fa834f3979a5",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 120,
        "bottom": 0,
        "left": 60
      }
    },
    "country.row.on": {
      "path": "apps/client/public/art/lang-cut/row.en.png",
      "pixelW": 378,
      "pixelH": 114,
      "alpha": true,
      "sha256": "a26cedadd521054fc1cf09977f9fbca9fe5604f504fd4f20630df4c5a864dbe0",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 120,
        "bottom": 0,
        "left": 60
      }
    },
    "scroll.track": {
      "path": "apps/client/public/art/scroll/slice/track.png",
      "pixelW": 34,
      "pixelH": 272,
      "alpha": true,
      "sha256": "a0de9241bc0885e497242c2c6e77609885be8453ba0de0aa420f3122011ff46d",
      "reused": true,
      "slicePx": {
        "top": 22,
        "right": 0,
        "bottom": 22,
        "left": 0
      }
    },
    "scroll.thumb": {
      "path": "apps/client/public/art/scroll/slice/thumb.png",
      "pixelW": 34,
      "pixelH": 136,
      "alpha": true,
      "sha256": "c1cae05f42413e3459484a7657dc601c76a39d036e604d1a0580da3323e20b28",
      "reused": true,
      "slicePx": {
        "top": 26,
        "right": 0,
        "bottom": 26,
        "left": 0
      }
    }
  },
  "coordinateContract": "Each element, text and hitTarget has a parent block; x/y is relative to that block. Blocks stack in document flow. proofY is evidence only, never an absolute application position.",
  "flow": {
    "width": 835,
    "centerX": 470.5,
    "gap": 20,
    "after": "pf-box-details",
    "before": "pf-cta",
    "sizing": "content-driven height; keep 941 × 1672 as the scale base",
    "order": [
      "about",
      "where",
      "bio"
    ],
    "bottomMarginAfterContinue": 80
  },
  "textContract": {
    "font": "Nunito",
    "fontPath": "apps/client/public/fonts/Nunito-latin.woff2",
    "fontSha256": "ba344451eab25b217a165363b1982048a5e5830a0daf36577973955a04cac793",
    "trackingEm": 0,
    "roles": {
      "title": {
        "size": 48,
        "weight": 800,
        "lineHeight": 60
      },
      "topic": {
        "size": 37,
        "weight": 800,
        "lineHeight": 47
      },
      "question": {
        "size": 42,
        "weight": 700,
        "lineHeight": 54
      },
      "body": {
        "size": 42,
        "weight": 600,
        "lineHeight": 54
      },
      "chip": {
        "size": 26,
        "weight": 700,
        "lineHeight": 33
      },
      "field": {
        "size": 42,
        "weight": 600,
        "lineHeight": 47
      },
      "bio": {
        "size": 42,
        "weight": 600,
        "lineHeight": 47
      },
      "caption": {
        "size": 37,
        "weight": 600,
        "lineHeight": 47
      },
      "error": {
        "size": 37,
        "weight": 700,
        "lineHeight": 47
      }
    },
    "overflow": "Questions and country names wrap without truncation. Chip words never wrap, shrink, scale, track, or ellipsize. City is an ordinary one-line input with caret scrolling. Bio is exactly two visible lines; never a scrollbox."
  },
  "colors": {
    "white": "#ffffff",
    "selected": "#ffe36a",
    "secondary": "#b9cdf0",
    "placeholder": "#9eb3e9",
    "error": "#ffb4c8",
    "disabled": "#8f9ac4"
  },
  "blocks": [
    {
      "id": "about",
      "render": "flow",
      "w": 835,
      "h": 4231,
      "heightMode": "intrinsic",
      "marginTop": 20,
      "frame": "profile.frame",
      "frameSlicePx": 112,
      "frameBorderWidth": 56
    },
    {
      "id": "where",
      "render": "flow",
      "w": 835,
      "h": 633,
      "heightMode": "intrinsic",
      "marginTop": 20,
      "frame": "profile.frame",
      "frameSlicePx": 112,
      "frameBorderWidth": 56
    },
    {
      "id": "bio",
      "render": "flow",
      "w": 835,
      "h": 472,
      "heightMode": "intrinsic",
      "marginTop": 20,
      "frame": "profile.frame",
      "frameSlicePx": 112,
      "frameBorderWidth": 56
    }
  ],
  "elements": [
    {
      "id": "tag.role.performer",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 344,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 356,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.joker",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 344,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 356,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.storyteller",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 344,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 356,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.icebreaker",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 468,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 480,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.leader",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 468,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 480,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.motivator",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 468,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 480,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.sociable",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 592,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 604,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.team-player",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 592,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 604,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.caretaker",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 592,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 604,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.listener",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 716,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 728,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.observer",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 716,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 728,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.lone-wolf",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 716,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 728,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.role.rebel",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 840,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 852,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.daredevil",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 1177,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 1189,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.competitive",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 1177,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 1189,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.explorer",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 1177,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 1189,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.curious",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 1301,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 1313,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.dreamer",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 1301,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 1313,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.skeptic",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 1301,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 1313,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.overthinker",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 1425,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 1437,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.cautious",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 1425,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 1437,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.experiences.homebody",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 1425,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 1437,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.saver",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 1816,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 1828,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.thrifty",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 1816,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 1828,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.spender",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 1816,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 1828,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.generous",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 1940,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 1952,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.investor",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 1940,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 1952,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.minimalist",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 1940,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 1952,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.deal-hunter",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 2064,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 2076,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.money.collector",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 2064,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 2076,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.direct",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 2401,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 2413,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.diplomat",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 2401,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 2413,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.peaceful",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 2401,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 2413,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.debater",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 2525,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 2537,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.fiery",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 2525,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 2537,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.stubborn",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 2525,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 2537,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.logical",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 2649,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 2661,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.sarcastic",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 2649,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 2661,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.playful",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 2649,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 2661,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.quiet",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 2773,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 2785,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.talk.chatty",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 2773,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 2785,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.open-book",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3110,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3122,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.oversharer",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3110,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3122,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.expressive",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 3110,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 3122,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.trusting",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3234,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3246,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.selective",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3234,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3246,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.reserved",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 3234,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 3246,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.shy",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3358,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3370,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.sharing.private",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3358,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3370,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.planner",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3695,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3707,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.steady",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3695,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3707,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.driven",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 3695,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 3707,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.adaptable",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3819,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3831,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.laid-back",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3819,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3831,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.free-spirit",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 3819,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 3831,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.spontaneous",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 3943,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 3955,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.last-minute",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 3943,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 3955,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.impulsive",
      "parent": "about",
      "piece": "pill.off",
      "x": 545,
      "y": 3943,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 557,
        "y": 3955,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.night-owl",
      "parent": "about",
      "piece": "pill.off",
      "x": 41,
      "y": 4067,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 53,
        "y": 4079,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "tag.tempo.early-bird",
      "parent": "about",
      "piece": "pill.off",
      "x": 293,
      "y": 4067,
      "w": 252,
      "h": 100,
      "render": "3-slice",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "capStage": 60,
      "controlBoxStage": {
        "x": 305,
        "y": 4079,
        "w": 228,
        "h": 76
      }
    },
    {
      "id": "about.frame",
      "parent": "about",
      "piece": "profile.frame",
      "x": 0,
      "y": 0,
      "w": 835,
      "h": 4231,
      "render": "border-image",
      "z": 20,
      "slicePx": {
        "top": 112,
        "right": 112,
        "bottom": 112,
        "left": 112
      },
      "borderWidth": 56,
      "fill": true
    },
    {
      "id": "country.field",
      "parent": "where",
      "piece": "field",
      "x": 41,
      "y": 201,
      "w": 753,
      "h": 152,
      "render": "border-image",
      "z": 21,
      "slicePx": {
        "top": 56,
        "right": 112,
        "bottom": 56,
        "left": 112
      },
      "borderWidth": {
        "top": 28,
        "right": 56,
        "bottom": 28,
        "left": 56
      },
      "fill": true
    },
    {
      "id": "country.chevron",
      "parent": "where",
      "piece": "chevron",
      "x": 715,
      "y": 260,
      "w": 34,
      "h": 34,
      "render": "image",
      "z": 21
    },
    {
      "id": "city.field",
      "parent": "where",
      "piece": "field",
      "x": 41,
      "y": 461,
      "w": 753,
      "h": 116,
      "render": "border-image",
      "z": 21,
      "slicePx": {
        "top": 56,
        "right": 112,
        "bottom": 56,
        "left": 112
      },
      "borderWidth": {
        "top": 28,
        "right": 56,
        "bottom": 28,
        "left": 56
      },
      "fill": true
    },
    {
      "id": "where.frame",
      "parent": "where",
      "piece": "profile.frame",
      "x": 0,
      "y": 0,
      "w": 835,
      "h": 633,
      "render": "border-image",
      "z": 20,
      "slicePx": {
        "top": 112,
        "right": 112,
        "bottom": 112,
        "left": 112
      },
      "borderWidth": 56,
      "fill": true
    },
    {
      "id": "bio.field",
      "parent": "bio",
      "piece": "field",
      "x": 41,
      "y": 192,
      "w": 753,
      "h": 158,
      "render": "border-image",
      "z": 21,
      "slicePx": {
        "top": 56,
        "right": 112,
        "bottom": 56,
        "left": 112
      },
      "borderWidth": {
        "top": 28,
        "right": 56,
        "bottom": 28,
        "left": 56
      },
      "fill": true
    },
    {
      "id": "bio.frame",
      "parent": "bio",
      "piece": "profile.frame",
      "x": 0,
      "y": 0,
      "w": 835,
      "h": 472,
      "render": "border-image",
      "z": 20,
      "slicePx": {
        "top": 112,
        "right": 112,
        "bottom": 112,
        "left": 112
      },
      "borderWidth": 56,
      "fill": true
    }
  ],
  "texts": [
    {
      "id": "about.title",
      "parent": "about",
      "text": "ABOUT YOU",
      "role": "title",
      "font": "Nunito",
      "size": 48,
      "weight": 800,
      "lineHeight": 60,
      "trackingEm": 0,
      "x": 41,
      "y": 45,
      "w": 753,
      "h": 60,
      "capCenterY": 75,
      "maxW": 753,
      "align": "center",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "about.instruction",
      "parent": "about",
      "text": "Pick what feels most like you.",
      "role": "body",
      "font": "Nunito",
      "size": 42,
      "weight": 600,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 123,
      "w": 729,
      "h": 54,
      "capCenterY": 150,
      "maxW": 729,
      "align": "center",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "role.heading",
      "parent": "about",
      "text": "ROLE",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 213,
      "w": 729,
      "h": 47,
      "capCenterY": 236.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "role.question",
      "parent": "about",
      "text": "In a group, which describes you best?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 270,
      "w": 729,
      "h": 54,
      "capCenterY": 297,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "In a group, which describes you best?"
      ],
      "catalogQuestion": "ROLE"
    },
    {
      "id": "tag.role.performer.label",
      "parent": "about",
      "text": "Performer",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 377.5,
      "w": 178,
      "h": 33,
      "capCenterY": 394,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.performer",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.joker.label",
      "parent": "about",
      "text": "Joker",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 377.5,
      "w": 178,
      "h": 33,
      "capCenterY": 394,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.joker",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.storyteller.label",
      "parent": "about",
      "text": "Storyteller",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 377.5,
      "w": 178,
      "h": 33,
      "capCenterY": 394,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.storyteller",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.icebreaker.label",
      "parent": "about",
      "text": "Icebreaker",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 501.5,
      "w": 178,
      "h": 33,
      "capCenterY": 518,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.icebreaker",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.leader.label",
      "parent": "about",
      "text": "Leader",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 501.5,
      "w": 178,
      "h": 33,
      "capCenterY": 518,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.leader",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.motivator.label",
      "parent": "about",
      "text": "Motivator",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 501.5,
      "w": 178,
      "h": 33,
      "capCenterY": 518,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.motivator",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.sociable.label",
      "parent": "about",
      "text": "Sociable",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 625.5,
      "w": 178,
      "h": 33,
      "capCenterY": 642,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.sociable",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.team-player.label",
      "parent": "about",
      "text": "Team player",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 625.5,
      "w": 178,
      "h": 33,
      "capCenterY": 642,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.team-player",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.caretaker.label",
      "parent": "about",
      "text": "Caretaker",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 625.5,
      "w": 178,
      "h": 33,
      "capCenterY": 642,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.caretaker",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.listener.label",
      "parent": "about",
      "text": "Listener",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 749.5,
      "w": 178,
      "h": 33,
      "capCenterY": 766,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.listener",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.observer.label",
      "parent": "about",
      "text": "Observer",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 749.5,
      "w": 178,
      "h": 33,
      "capCenterY": 766,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.observer",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.lone-wolf.label",
      "parent": "about",
      "text": "Lone wolf",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 749.5,
      "w": 178,
      "h": 33,
      "capCenterY": 766,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.lone-wolf",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.role.rebel.label",
      "parent": "about",
      "text": "Rebel",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 873.5,
      "w": 178,
      "h": 33,
      "capCenterY": 890,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "role.rebel",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "experiences.heading",
      "parent": "about",
      "text": "EXPERIENCES",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 992,
      "w": 729,
      "h": 47,
      "capCenterY": 1015.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "experiences.question",
      "parent": "about",
      "text": "Which describes your approach to new experiences and challenges?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 1049,
      "w": 729,
      "h": 108,
      "capCenterY": 1103,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "Which describes your approach to",
        "new experiences and challenges?"
      ],
      "catalogQuestion": "EXPERIENCES"
    },
    {
      "id": "tag.experiences.daredevil.label",
      "parent": "about",
      "text": "Daredevil",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 1210.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1227,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.daredevil",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.competitive.label",
      "parent": "about",
      "text": "Competitive",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 1210.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1227,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.competitive",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.explorer.label",
      "parent": "about",
      "text": "Explorer",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 1210.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1227,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.explorer",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.curious.label",
      "parent": "about",
      "text": "Curious",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 1334.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1351,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.curious",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.dreamer.label",
      "parent": "about",
      "text": "Dreamer",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 1334.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1351,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.dreamer",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.skeptic.label",
      "parent": "about",
      "text": "Skeptic",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 1334.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1351,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.skeptic",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.overthinker.label",
      "parent": "about",
      "text": "Overthinker",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 1458.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1475,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.overthinker",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.cautious.label",
      "parent": "about",
      "text": "Cautious",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 1458.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1475,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.cautious",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.experiences.homebody.label",
      "parent": "about",
      "text": "Homebody",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 1458.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1475,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "experiences.homebody",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "money.heading",
      "parent": "about",
      "text": "MONEY",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 1577,
      "w": 729,
      "h": 47,
      "capCenterY": 1600.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "money.question",
      "parent": "about",
      "text": "When it comes to money and possessions, which describes you best?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 1634,
      "w": 729,
      "h": 162,
      "capCenterY": 1715,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "When it comes to money and",
        "possessions, which describes you",
        "best?"
      ],
      "catalogQuestion": "MONEY"
    },
    {
      "id": "tag.money.saver.label",
      "parent": "about",
      "text": "Saver",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 1849.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1866,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.saver",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.thrifty.label",
      "parent": "about",
      "text": "Thrifty",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 1849.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1866,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.thrifty",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.spender.label",
      "parent": "about",
      "text": "Spender",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 1849.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1866,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.spender",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.generous.label",
      "parent": "about",
      "text": "Generous",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 1973.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1990,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.generous",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.investor.label",
      "parent": "about",
      "text": "Investor",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 1973.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1990,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.investor",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.minimalist.label",
      "parent": "about",
      "text": "Minimalist",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 1973.5,
      "w": 178,
      "h": 33,
      "capCenterY": 1990,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.minimalist",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.deal-hunter.label",
      "parent": "about",
      "text": "Deal hunter",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 2097.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2114,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.deal-hunter",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.money.collector.label",
      "parent": "about",
      "text": "Collector",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 2097.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2114,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "money.collector",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "talk.heading",
      "parent": "about",
      "text": "TALK",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 2216,
      "w": 729,
      "h": 47,
      "capCenterY": 2239.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "talk.question",
      "parent": "about",
      "text": "In conversations and disagreements, which describes you best?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 2273,
      "w": 729,
      "h": 108,
      "capCenterY": 2327,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "In conversations and disagreements,",
        "which describes you best?"
      ],
      "catalogQuestion": "TALK"
    },
    {
      "id": "tag.talk.direct.label",
      "parent": "about",
      "text": "Direct",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 2434.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2451,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.direct",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.diplomat.label",
      "parent": "about",
      "text": "Diplomat",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 2434.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2451,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.diplomat",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.peaceful.label",
      "parent": "about",
      "text": "Peaceful",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 2434.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2451,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.peaceful",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.debater.label",
      "parent": "about",
      "text": "Debater",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 2558.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2575,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.debater",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.fiery.label",
      "parent": "about",
      "text": "Fiery",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 2558.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2575,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.fiery",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.stubborn.label",
      "parent": "about",
      "text": "Stubborn",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 2558.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2575,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.stubborn",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.logical.label",
      "parent": "about",
      "text": "Logical",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 2682.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2699,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.logical",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.sarcastic.label",
      "parent": "about",
      "text": "Sarcastic",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 2682.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2699,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.sarcastic",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.playful.label",
      "parent": "about",
      "text": "Playful",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 2682.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2699,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.playful",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.quiet.label",
      "parent": "about",
      "text": "Quiet",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 2806.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2823,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.quiet",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.talk.chatty.label",
      "parent": "about",
      "text": "Chatty",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 2806.5,
      "w": 178,
      "h": 33,
      "capCenterY": 2823,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "talk.chatty",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "sharing.heading",
      "parent": "about",
      "text": "SHARING",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 2925,
      "w": 729,
      "h": 47,
      "capCenterY": 2948.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "sharing.question",
      "parent": "about",
      "text": "When letting others get to know you, which describes you best?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 2982,
      "w": 729,
      "h": 108,
      "capCenterY": 3036,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "When letting others get to know",
        "you, which describes you best?"
      ],
      "catalogQuestion": "SHARING"
    },
    {
      "id": "tag.sharing.open-book.label",
      "parent": "about",
      "text": "Open book",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3143.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3160,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.open-book",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.oversharer.label",
      "parent": "about",
      "text": "Oversharer",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3143.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3160,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.oversharer",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.expressive.label",
      "parent": "about",
      "text": "Expressive",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 3143.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3160,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.expressive",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.trusting.label",
      "parent": "about",
      "text": "Trusting",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3267.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3284,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.trusting",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.selective.label",
      "parent": "about",
      "text": "Selective",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3267.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3284,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.selective",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.reserved.label",
      "parent": "about",
      "text": "Reserved",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 3267.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3284,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.reserved",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.shy.label",
      "parent": "about",
      "text": "Shy",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3391.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3408,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.shy",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.sharing.private.label",
      "parent": "about",
      "text": "Private",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3391.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3408,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "sharing.private",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tempo.heading",
      "parent": "about",
      "text": "TEMPO",
      "role": "topic",
      "font": "Nunito",
      "size": 37,
      "weight": 800,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 3510,
      "w": 729,
      "h": 47,
      "capCenterY": 3533.5,
      "maxW": 729,
      "align": "left",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "tempo.question",
      "parent": "about",
      "text": "With plans, goals and routines, which describes you best?",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 3567,
      "w": 729,
      "h": 108,
      "capCenterY": 3621,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "lines": [
        "With plans, goals and routines,",
        "which describes you best?"
      ],
      "catalogQuestion": "TEMPO"
    },
    {
      "id": "tag.tempo.planner.label",
      "parent": "about",
      "text": "Planner",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3728.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3745,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.planner",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.steady.label",
      "parent": "about",
      "text": "Steady",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3728.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3745,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.steady",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.driven.label",
      "parent": "about",
      "text": "Driven",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 3728.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3745,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.driven",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.adaptable.label",
      "parent": "about",
      "text": "Adaptable",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3852.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3869,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.adaptable",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.laid-back.label",
      "parent": "about",
      "text": "Laid-back",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3852.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3869,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.laid-back",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.free-spirit.label",
      "parent": "about",
      "text": "Free spirit",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 3852.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3869,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.free-spirit",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.spontaneous.label",
      "parent": "about",
      "text": "Spontaneous",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 3976.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3993,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.spontaneous",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.last-minute.label",
      "parent": "about",
      "text": "Last-minute",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 3976.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3993,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.last-minute",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.impulsive.label",
      "parent": "about",
      "text": "Impulsive",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 582,
      "y": 3976.5,
      "w": 178,
      "h": 33,
      "capCenterY": 3993,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.impulsive",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.night-owl.label",
      "parent": "about",
      "text": "Night owl",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 78,
      "y": 4100.5,
      "w": 178,
      "h": 33,
      "capCenterY": 4117,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.night-owl",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "tag.tempo.early-bird.label",
      "parent": "about",
      "text": "Early bird",
      "role": "chip",
      "font": "Nunito",
      "size": 26,
      "weight": 700,
      "lineHeight": 33,
      "trackingEm": 0,
      "x": 330,
      "y": 4100.5,
      "w": 178,
      "h": 33,
      "capCenterY": 4117,
      "maxW": 178,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "catalogId": "tempo.early-bird",
      "paddingFromInnerNeon": 16
    },
    {
      "id": "where.title",
      "parent": "where",
      "text": "WHERE YOU ARE",
      "role": "title",
      "font": "Nunito",
      "size": 48,
      "weight": 800,
      "lineHeight": 60,
      "trackingEm": 0,
      "x": 41,
      "y": 45,
      "w": 753,
      "h": 60,
      "capCenterY": 75,
      "maxW": 753,
      "align": "center",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "country.label",
      "parent": "where",
      "text": "Country",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 133,
      "w": 729,
      "h": 54,
      "capCenterY": 160,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "country.value",
      "parent": "where",
      "text": "Choose your country",
      "role": "field",
      "font": "Nunito",
      "size": 42,
      "weight": 600,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 81,
      "y": 230,
      "w": 612,
      "h": 94,
      "capCenterY": 277,
      "maxW": 612,
      "align": "left",
      "color": "#9eb3e9",
      "z": 46,
      "placeholder": true,
      "binding": "card.country -> COUNTRY_NAMES[code]",
      "verticalAlign": "center",
      "lines": [
        "Choose your country"
      ]
    },
    {
      "id": "city.label",
      "parent": "where",
      "text": "City (optional)",
      "role": "question",
      "font": "Nunito",
      "size": 42,
      "weight": 700,
      "lineHeight": 54,
      "trackingEm": 0,
      "x": 53,
      "y": 393,
      "w": 729,
      "h": 54,
      "capCenterY": 420,
      "maxW": 729,
      "align": "left",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "city.value",
      "parent": "where",
      "text": "Your city",
      "role": "field",
      "font": "Nunito",
      "size": 42,
      "weight": 600,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 81,
      "y": 495.5,
      "w": 673,
      "h": 47,
      "capCenterY": 519,
      "maxW": 673,
      "align": "left",
      "color": "#9eb3e9",
      "z": 46,
      "placeholder": true,
      "binding": "card.city",
      "maxLength": 40
    },
    {
      "id": "bio.title",
      "parent": "bio",
      "text": "A FEW WORDS ABOUT YOU",
      "role": "title",
      "font": "Nunito",
      "size": 48,
      "weight": 800,
      "lineHeight": 60,
      "trackingEm": 0,
      "x": 41,
      "y": 45,
      "w": 753,
      "h": 60,
      "capCenterY": 75,
      "maxW": 753,
      "align": "center",
      "color": "#ffffff",
      "z": 46
    },
    {
      "id": "bio.optional",
      "parent": "bio",
      "text": "Optional · two lines",
      "role": "caption",
      "font": "Nunito",
      "size": 37,
      "weight": 600,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 121,
      "w": 729,
      "h": 47,
      "capCenterY": 144.5,
      "maxW": 729,
      "align": "center",
      "color": "#b9cdf0",
      "z": 46
    },
    {
      "id": "bio.value",
      "parent": "bio",
      "text": "Tell us a little about you.",
      "role": "bio",
      "font": "Nunito",
      "size": 42,
      "weight": 600,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 81,
      "y": 224,
      "w": 673,
      "h": 94,
      "capCenterY": 271,
      "maxW": 673,
      "align": "left",
      "color": "#9eb3e9",
      "z": 46,
      "placeholder": true,
      "lines": [
        "Tell us a little about you."
      ],
      "binding": "card.bio",
      "rows": 2,
      "resize": "none",
      "scroll": "none"
    },
    {
      "id": "bio.count",
      "parent": "bio",
      "text": "0 / 28",
      "role": "caption",
      "font": "Nunito",
      "size": 37,
      "weight": 600,
      "lineHeight": 47,
      "trackingEm": 0,
      "x": 53,
      "y": 369,
      "w": 729,
      "h": 47,
      "capCenterY": 392.5,
      "maxW": 729,
      "align": "right",
      "color": "#b9cdf0",
      "z": 46,
      "binding": "draft.bio character count / proposed limit"
    }
  ],
  "hitTargets": [
    {
      "id": "tag.role.performer",
      "parent": "about",
      "x": 53,
      "y": 336,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Performer",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.performer"
    },
    {
      "id": "tag.role.joker",
      "parent": "about",
      "x": 305,
      "y": 336,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Joker",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.joker"
    },
    {
      "id": "tag.role.storyteller",
      "parent": "about",
      "x": 557,
      "y": 336,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Storyteller",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.storyteller"
    },
    {
      "id": "tag.role.icebreaker",
      "parent": "about",
      "x": 53,
      "y": 460,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Icebreaker",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.icebreaker"
    },
    {
      "id": "tag.role.leader",
      "parent": "about",
      "x": 305,
      "y": 460,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Leader",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.leader"
    },
    {
      "id": "tag.role.motivator",
      "parent": "about",
      "x": 557,
      "y": 460,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Motivator",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.motivator"
    },
    {
      "id": "tag.role.sociable",
      "parent": "about",
      "x": 53,
      "y": 584,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Sociable",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.sociable"
    },
    {
      "id": "tag.role.team-player",
      "parent": "about",
      "x": 305,
      "y": 584,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Team player",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.team-player"
    },
    {
      "id": "tag.role.caretaker",
      "parent": "about",
      "x": 557,
      "y": 584,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Caretaker",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.caretaker"
    },
    {
      "id": "tag.role.listener",
      "parent": "about",
      "x": 53,
      "y": 708,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Listener",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.listener"
    },
    {
      "id": "tag.role.observer",
      "parent": "about",
      "x": 305,
      "y": 708,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Observer",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.observer"
    },
    {
      "id": "tag.role.lone-wolf",
      "parent": "about",
      "x": 557,
      "y": 708,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Lone wolf",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.lone-wolf"
    },
    {
      "id": "tag.role.rebel",
      "parent": "about",
      "x": 53,
      "y": 832,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "ROLE: Rebel",
      "ariaChecked": false,
      "group": "ROLE",
      "value": "role.rebel"
    },
    {
      "id": "tag.experiences.daredevil",
      "parent": "about",
      "x": 53,
      "y": 1169,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Daredevil",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.daredevil"
    },
    {
      "id": "tag.experiences.competitive",
      "parent": "about",
      "x": 305,
      "y": 1169,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Competitive",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.competitive"
    },
    {
      "id": "tag.experiences.explorer",
      "parent": "about",
      "x": 557,
      "y": 1169,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Explorer",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.explorer"
    },
    {
      "id": "tag.experiences.curious",
      "parent": "about",
      "x": 53,
      "y": 1293,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Curious",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.curious"
    },
    {
      "id": "tag.experiences.dreamer",
      "parent": "about",
      "x": 305,
      "y": 1293,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Dreamer",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.dreamer"
    },
    {
      "id": "tag.experiences.skeptic",
      "parent": "about",
      "x": 557,
      "y": 1293,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Skeptic",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.skeptic"
    },
    {
      "id": "tag.experiences.overthinker",
      "parent": "about",
      "x": 53,
      "y": 1417,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Overthinker",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.overthinker"
    },
    {
      "id": "tag.experiences.cautious",
      "parent": "about",
      "x": 305,
      "y": 1417,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Cautious",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.cautious"
    },
    {
      "id": "tag.experiences.homebody",
      "parent": "about",
      "x": 557,
      "y": 1417,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "EXPERIENCES: Homebody",
      "ariaChecked": false,
      "group": "EXPERIENCES",
      "value": "experiences.homebody"
    },
    {
      "id": "tag.money.saver",
      "parent": "about",
      "x": 53,
      "y": 1808,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Saver",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.saver"
    },
    {
      "id": "tag.money.thrifty",
      "parent": "about",
      "x": 305,
      "y": 1808,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Thrifty",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.thrifty"
    },
    {
      "id": "tag.money.spender",
      "parent": "about",
      "x": 557,
      "y": 1808,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Spender",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.spender"
    },
    {
      "id": "tag.money.generous",
      "parent": "about",
      "x": 53,
      "y": 1932,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Generous",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.generous"
    },
    {
      "id": "tag.money.investor",
      "parent": "about",
      "x": 305,
      "y": 1932,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Investor",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.investor"
    },
    {
      "id": "tag.money.minimalist",
      "parent": "about",
      "x": 557,
      "y": 1932,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Minimalist",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.minimalist"
    },
    {
      "id": "tag.money.deal-hunter",
      "parent": "about",
      "x": 53,
      "y": 2056,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Deal hunter",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.deal-hunter"
    },
    {
      "id": "tag.money.collector",
      "parent": "about",
      "x": 305,
      "y": 2056,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "MONEY: Collector",
      "ariaChecked": false,
      "group": "MONEY",
      "value": "money.collector"
    },
    {
      "id": "tag.talk.direct",
      "parent": "about",
      "x": 53,
      "y": 2393,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Direct",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.direct"
    },
    {
      "id": "tag.talk.diplomat",
      "parent": "about",
      "x": 305,
      "y": 2393,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Diplomat",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.diplomat"
    },
    {
      "id": "tag.talk.peaceful",
      "parent": "about",
      "x": 557,
      "y": 2393,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Peaceful",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.peaceful"
    },
    {
      "id": "tag.talk.debater",
      "parent": "about",
      "x": 53,
      "y": 2517,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Debater",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.debater"
    },
    {
      "id": "tag.talk.fiery",
      "parent": "about",
      "x": 305,
      "y": 2517,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Fiery",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.fiery"
    },
    {
      "id": "tag.talk.stubborn",
      "parent": "about",
      "x": 557,
      "y": 2517,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Stubborn",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.stubborn"
    },
    {
      "id": "tag.talk.logical",
      "parent": "about",
      "x": 53,
      "y": 2641,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Logical",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.logical"
    },
    {
      "id": "tag.talk.sarcastic",
      "parent": "about",
      "x": 305,
      "y": 2641,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Sarcastic",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.sarcastic"
    },
    {
      "id": "tag.talk.playful",
      "parent": "about",
      "x": 557,
      "y": 2641,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Playful",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.playful"
    },
    {
      "id": "tag.talk.quiet",
      "parent": "about",
      "x": 53,
      "y": 2765,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Quiet",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.quiet"
    },
    {
      "id": "tag.talk.chatty",
      "parent": "about",
      "x": 305,
      "y": 2765,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TALK: Chatty",
      "ariaChecked": false,
      "group": "TALK",
      "value": "talk.chatty"
    },
    {
      "id": "tag.sharing.open-book",
      "parent": "about",
      "x": 53,
      "y": 3102,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Open book",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.open-book"
    },
    {
      "id": "tag.sharing.oversharer",
      "parent": "about",
      "x": 305,
      "y": 3102,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Oversharer",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.oversharer"
    },
    {
      "id": "tag.sharing.expressive",
      "parent": "about",
      "x": 557,
      "y": 3102,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Expressive",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.expressive"
    },
    {
      "id": "tag.sharing.trusting",
      "parent": "about",
      "x": 53,
      "y": 3226,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Trusting",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.trusting"
    },
    {
      "id": "tag.sharing.selective",
      "parent": "about",
      "x": 305,
      "y": 3226,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Selective",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.selective"
    },
    {
      "id": "tag.sharing.reserved",
      "parent": "about",
      "x": 557,
      "y": 3226,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Reserved",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.reserved"
    },
    {
      "id": "tag.sharing.shy",
      "parent": "about",
      "x": 53,
      "y": 3350,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Shy",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.shy"
    },
    {
      "id": "tag.sharing.private",
      "parent": "about",
      "x": 305,
      "y": 3350,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "SHARING: Private",
      "ariaChecked": false,
      "group": "SHARING",
      "value": "sharing.private"
    },
    {
      "id": "tag.tempo.planner",
      "parent": "about",
      "x": 53,
      "y": 3687,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Planner",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.planner"
    },
    {
      "id": "tag.tempo.steady",
      "parent": "about",
      "x": 305,
      "y": 3687,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Steady",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.steady"
    },
    {
      "id": "tag.tempo.driven",
      "parent": "about",
      "x": 557,
      "y": 3687,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Driven",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.driven"
    },
    {
      "id": "tag.tempo.adaptable",
      "parent": "about",
      "x": 53,
      "y": 3811,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Adaptable",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.adaptable"
    },
    {
      "id": "tag.tempo.laid-back",
      "parent": "about",
      "x": 305,
      "y": 3811,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Laid-back",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.laid-back"
    },
    {
      "id": "tag.tempo.free-spirit",
      "parent": "about",
      "x": 557,
      "y": 3811,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Free spirit",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.free-spirit"
    },
    {
      "id": "tag.tempo.spontaneous",
      "parent": "about",
      "x": 53,
      "y": 3935,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Spontaneous",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.spontaneous"
    },
    {
      "id": "tag.tempo.last-minute",
      "parent": "about",
      "x": 305,
      "y": 3935,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Last-minute",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.last-minute"
    },
    {
      "id": "tag.tempo.impulsive",
      "parent": "about",
      "x": 557,
      "y": 3935,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Impulsive",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.impulsive"
    },
    {
      "id": "tag.tempo.night-owl",
      "parent": "about",
      "x": 53,
      "y": 4059,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Night owl",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.night-owl"
    },
    {
      "id": "tag.tempo.early-bird",
      "parent": "about",
      "x": 305,
      "y": 4059,
      "w": 228,
      "h": 116,
      "action": "choose-topic",
      "enabled": true,
      "role": "radio",
      "ariaLabel": "TEMPO: Early bird",
      "ariaChecked": false,
      "group": "TEMPO",
      "value": "tempo.early-bird"
    },
    {
      "id": "country",
      "parent": "where",
      "x": 41,
      "y": 201,
      "w": 753,
      "h": 152,
      "action": "open-country-list",
      "enabled": true,
      "role": "button",
      "ariaLabel": "Country",
      "ariaHasPopup": "dialog"
    },
    {
      "id": "city",
      "parent": "where",
      "x": 41,
      "y": 461,
      "w": 753,
      "h": 116,
      "action": "edit-city",
      "enabled": true,
      "role": "textbox",
      "ariaLabel": "City (optional)",
      "maxLength": 40,
      "required": false
    },
    {
      "id": "bio",
      "parent": "bio",
      "x": 41,
      "y": 192,
      "w": 753,
      "h": 158,
      "action": "edit-bio",
      "enabled": true,
      "role": "textbox",
      "ariaLabel": "A few words about you (optional)",
      "ariaMultiline": true,
      "rows": 2,
      "required": false,
      "proposedMaxLength": 28
    }
  ],
  "topics": [
    {
      "topic": "ROLE",
      "question": "In a group, which describes you best?",
      "questionLines": [
        "In a group, which describes you best?"
      ],
      "count": 13,
      "options": [
        "Performer",
        "Joker",
        "Storyteller",
        "Icebreaker",
        "Leader",
        "Motivator",
        "Sociable",
        "Team player",
        "Caretaker",
        "Listener",
        "Observer",
        "Lone wolf",
        "Rebel"
      ],
      "radioGroup": "ROLE",
      "defaultValue": null,
      "x": 53,
      "y": 213,
      "h": 735,
      "firstHitY": 336,
      "columns": 3,
      "rows": 5,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Team player",
        "advance": 147.96599999999998
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 198
    },
    {
      "topic": "EXPERIENCES",
      "question": "Which describes your approach to new experiences and challenges?",
      "questionLines": [
        "Which describes your approach to",
        "new experiences and challenges?"
      ],
      "count": 9,
      "options": [
        "Daredevil",
        "Competitive",
        "Explorer",
        "Curious",
        "Dreamer",
        "Skeptic",
        "Overthinker",
        "Cautious",
        "Homebody"
      ],
      "radioGroup": "EXPERIENCES",
      "defaultValue": null,
      "x": 53,
      "y": 992,
      "h": 541,
      "firstHitY": 1169,
      "columns": 3,
      "rows": 3,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Competitive",
        "advance": 145.626
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 196
    },
    {
      "topic": "MONEY",
      "question": "When it comes to money and possessions, which describes you best?",
      "questionLines": [
        "When it comes to money and",
        "possessions, which describes you",
        "best?"
      ],
      "count": 8,
      "options": [
        "Saver",
        "Thrifty",
        "Spender",
        "Generous",
        "Investor",
        "Minimalist",
        "Deal hunter",
        "Collector"
      ],
      "radioGroup": "MONEY",
      "defaultValue": null,
      "x": 53,
      "y": 1577,
      "h": 595,
      "firstHitY": 1808,
      "columns": 3,
      "rows": 3,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Deal hunter",
        "advance": 143.078
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 194
    },
    {
      "topic": "TALK",
      "question": "In conversations and disagreements, which describes you best?",
      "questionLines": [
        "In conversations and disagreements,",
        "which describes you best?"
      ],
      "count": 11,
      "options": [
        "Direct",
        "Diplomat",
        "Peaceful",
        "Debater",
        "Fiery",
        "Stubborn",
        "Logical",
        "Sarcastic",
        "Playful",
        "Quiet",
        "Chatty"
      ],
      "radioGroup": "TALK",
      "defaultValue": null,
      "x": 53,
      "y": 2216,
      "h": 665,
      "firstHitY": 2393,
      "columns": 3,
      "rows": 4,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Stubborn",
        "advance": 112.892
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 163
    },
    {
      "topic": "SHARING",
      "question": "When letting others get to know you, which describes you best?",
      "questionLines": [
        "When letting others get to know",
        "you, which describes you best?"
      ],
      "count": 8,
      "options": [
        "Open book",
        "Oversharer",
        "Expressive",
        "Trusting",
        "Selective",
        "Reserved",
        "Shy",
        "Private"
      ],
      "radioGroup": "SHARING",
      "defaultValue": null,
      "x": 53,
      "y": 2925,
      "h": 541,
      "firstHitY": 3102,
      "columns": 3,
      "rows": 3,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Oversharer",
        "advance": 134.394
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 185
    },
    {
      "topic": "TEMPO",
      "question": "With plans, goals and routines, which describes you best?",
      "questionLines": [
        "With plans, goals and routines,",
        "which describes you best?"
      ],
      "count": 11,
      "options": [
        "Planner",
        "Steady",
        "Driven",
        "Adaptable",
        "Laid-back",
        "Free spirit",
        "Spontaneous",
        "Last-minute",
        "Impulsive",
        "Night owl",
        "Early bird"
      ],
      "radioGroup": "TEMPO",
      "defaultValue": null,
      "x": 53,
      "y": 3510,
      "h": 665,
      "firstHitY": 3687,
      "columns": 3,
      "rows": 4,
      "controlW": 228,
      "controlH": 76,
      "artW": 252,
      "artH": 100,
      "hitH": 116,
      "columnPitch": 252,
      "rowPitch": 124,
      "widest": {
        "word": "Spontaneous",
        "advance": 158.418
      },
      "safeTextLane": 178,
      "minimumControlWFromLaneRule": 209
    }
  ],
  "states": {
    "empty": {
      "elementOverrides": {},
      "textOverrides": {},
      "hitOverrides": {},
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {},
        "country": null,
        "city": "",
        "bio": ""
      },
      "continue": {
        "enabled": false,
        "appearance": "existing-grey",
        "action": "explain-missing-fields",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "filled": {
      "elementOverrides": {
        "tag.role.team-player": {
          "piece": "pill.on"
        },
        "tag.experiences.competitive": {
          "piece": "pill.on"
        },
        "tag.money.deal-hunter": {
          "piece": "pill.on"
        },
        "tag.talk.stubborn": {
          "piece": "pill.on"
        },
        "tag.sharing.oversharer": {
          "piece": "pill.on"
        },
        "tag.tempo.spontaneous": {
          "piece": "pill.on"
        }
      },
      "textOverrides": {
        "tag.role.team-player.label": {
          "color": "#ffe36a"
        },
        "tag.experiences.competitive.label": {
          "color": "#ffe36a"
        },
        "tag.money.deal-hunter.label": {
          "color": "#ffe36a"
        },
        "tag.talk.stubborn.label": {
          "color": "#ffe36a"
        },
        "tag.sharing.oversharer.label": {
          "color": "#ffe36a"
        },
        "tag.tempo.spontaneous.label": {
          "color": "#ffe36a"
        },
        "country.value": {
          "text": "Spain",
          "lines": [
            "Spain"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "city.value": {
          "text": "Madrid",
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.count": {
          "text": "28 / 28"
        }
      },
      "hitOverrides": {
        "tag.role.team-player": {
          "ariaChecked": true
        },
        "tag.experiences.competitive": {
          "ariaChecked": true
        },
        "tag.money.deal-hunter": {
          "ariaChecked": true
        },
        "tag.talk.stubborn": {
          "ariaChecked": true
        },
        "tag.sharing.oversharer": {
          "ariaChecked": true
        },
        "tag.tempo.spontaneous": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.team-player",
          "EXPERIENCES": "experiences.competitive",
          "MONEY": "money.deal-hunter",
          "TALK": "talk.stubborn",
          "SHARING": "sharing.oversharer",
          "TEMPO": "tempo.spontaneous"
        },
        "country": "ES",
        "city": "Madrid",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "existingFields": "valid review fixture"
      },
      "continue": {
        "enabled": true,
        "appearance": "existing-gold",
        "action": "save-current-profile",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "invalid": {
      "elementOverrides": {
        "tag.role.performer": {
          "y": 412
        },
        "tag.role.joker": {
          "y": 412
        },
        "tag.role.storyteller": {
          "y": 412
        },
        "tag.role.icebreaker": {
          "y": 536
        },
        "tag.role.leader": {
          "y": 536
        },
        "tag.role.motivator": {
          "y": 536
        },
        "tag.role.sociable": {
          "y": 660
        },
        "tag.role.team-player": {
          "y": 660
        },
        "tag.role.caretaker": {
          "y": 660
        },
        "tag.role.listener": {
          "y": 784
        },
        "tag.role.observer": {
          "y": 784
        },
        "tag.role.lone-wolf": {
          "y": 784
        },
        "tag.role.rebel": {
          "y": 908
        },
        "tag.experiences.daredevil": {
          "y": 1245
        },
        "tag.experiences.competitive": {
          "y": 1245
        },
        "tag.experiences.explorer": {
          "y": 1245
        },
        "tag.experiences.curious": {
          "y": 1369
        },
        "tag.experiences.dreamer": {
          "y": 1369
        },
        "tag.experiences.skeptic": {
          "y": 1369
        },
        "tag.experiences.overthinker": {
          "y": 1493
        },
        "tag.experiences.cautious": {
          "y": 1493
        },
        "tag.experiences.homebody": {
          "y": 1493
        },
        "tag.money.saver": {
          "y": 1884
        },
        "tag.money.thrifty": {
          "y": 1884
        },
        "tag.money.spender": {
          "y": 1884
        },
        "tag.money.generous": {
          "y": 2008
        },
        "tag.money.investor": {
          "y": 2008
        },
        "tag.money.minimalist": {
          "y": 2008
        },
        "tag.money.deal-hunter": {
          "y": 2132
        },
        "tag.money.collector": {
          "y": 2132
        },
        "tag.talk.direct": {
          "y": 2469
        },
        "tag.talk.diplomat": {
          "y": 2469
        },
        "tag.talk.peaceful": {
          "y": 2469
        },
        "tag.talk.debater": {
          "y": 2593
        },
        "tag.talk.fiery": {
          "y": 2593
        },
        "tag.talk.stubborn": {
          "y": 2593
        },
        "tag.talk.logical": {
          "y": 2717
        },
        "tag.talk.sarcastic": {
          "y": 2717
        },
        "tag.talk.playful": {
          "y": 2717
        },
        "tag.talk.quiet": {
          "y": 2841
        },
        "tag.talk.chatty": {
          "y": 2841
        },
        "tag.sharing.open-book": {
          "y": 3178
        },
        "tag.sharing.oversharer": {
          "y": 3178
        },
        "tag.sharing.expressive": {
          "y": 3178
        },
        "tag.sharing.trusting": {
          "y": 3302
        },
        "tag.sharing.selective": {
          "y": 3302
        },
        "tag.sharing.reserved": {
          "y": 3302
        },
        "tag.sharing.shy": {
          "y": 3426
        },
        "tag.sharing.private": {
          "y": 3426
        },
        "tag.tempo.planner": {
          "y": 3763
        },
        "tag.tempo.steady": {
          "y": 3763
        },
        "tag.tempo.driven": {
          "y": 3763
        },
        "tag.tempo.adaptable": {
          "y": 3887
        },
        "tag.tempo.laid-back": {
          "y": 3887
        },
        "tag.tempo.free-spirit": {
          "y": 3887
        },
        "tag.tempo.spontaneous": {
          "y": 4011
        },
        "tag.tempo.last-minute": {
          "y": 4011
        },
        "tag.tempo.impulsive": {
          "y": 4011
        },
        "tag.tempo.night-owl": {
          "y": 4135
        },
        "tag.tempo.early-bird": {
          "y": 4135
        },
        "city.field": {
          "y": 529
        }
      },
      "textOverrides": {
        "role.heading": {
          "y": 281,
          "capCenterY": 304.5
        },
        "role.question": {
          "y": 338,
          "capCenterY": 365
        },
        "tag.role.performer.label": {
          "y": 445.5,
          "capCenterY": 462
        },
        "tag.role.joker.label": {
          "y": 445.5,
          "capCenterY": 462
        },
        "tag.role.storyteller.label": {
          "y": 445.5,
          "capCenterY": 462
        },
        "tag.role.icebreaker.label": {
          "y": 569.5,
          "capCenterY": 586
        },
        "tag.role.leader.label": {
          "y": 569.5,
          "capCenterY": 586
        },
        "tag.role.motivator.label": {
          "y": 569.5,
          "capCenterY": 586
        },
        "tag.role.sociable.label": {
          "y": 693.5,
          "capCenterY": 710
        },
        "tag.role.team-player.label": {
          "y": 693.5,
          "capCenterY": 710
        },
        "tag.role.caretaker.label": {
          "y": 693.5,
          "capCenterY": 710
        },
        "tag.role.listener.label": {
          "y": 817.5,
          "capCenterY": 834
        },
        "tag.role.observer.label": {
          "y": 817.5,
          "capCenterY": 834
        },
        "tag.role.lone-wolf.label": {
          "y": 817.5,
          "capCenterY": 834
        },
        "tag.role.rebel.label": {
          "y": 941.5,
          "capCenterY": 958
        },
        "experiences.heading": {
          "y": 1060,
          "capCenterY": 1083.5
        },
        "experiences.question": {
          "y": 1117,
          "capCenterY": 1171
        },
        "tag.experiences.daredevil.label": {
          "y": 1278.5,
          "capCenterY": 1295
        },
        "tag.experiences.competitive.label": {
          "y": 1278.5,
          "capCenterY": 1295
        },
        "tag.experiences.explorer.label": {
          "y": 1278.5,
          "capCenterY": 1295
        },
        "tag.experiences.curious.label": {
          "y": 1402.5,
          "capCenterY": 1419
        },
        "tag.experiences.dreamer.label": {
          "y": 1402.5,
          "capCenterY": 1419
        },
        "tag.experiences.skeptic.label": {
          "y": 1402.5,
          "capCenterY": 1419
        },
        "tag.experiences.overthinker.label": {
          "y": 1526.5,
          "capCenterY": 1543
        },
        "tag.experiences.cautious.label": {
          "y": 1526.5,
          "capCenterY": 1543
        },
        "tag.experiences.homebody.label": {
          "y": 1526.5,
          "capCenterY": 1543
        },
        "money.heading": {
          "y": 1645,
          "capCenterY": 1668.5
        },
        "money.question": {
          "y": 1702,
          "capCenterY": 1783
        },
        "tag.money.saver.label": {
          "y": 1917.5,
          "capCenterY": 1934
        },
        "tag.money.thrifty.label": {
          "y": 1917.5,
          "capCenterY": 1934
        },
        "tag.money.spender.label": {
          "y": 1917.5,
          "capCenterY": 1934
        },
        "tag.money.generous.label": {
          "y": 2041.5,
          "capCenterY": 2058
        },
        "tag.money.investor.label": {
          "y": 2041.5,
          "capCenterY": 2058
        },
        "tag.money.minimalist.label": {
          "y": 2041.5,
          "capCenterY": 2058
        },
        "tag.money.deal-hunter.label": {
          "y": 2165.5,
          "capCenterY": 2182
        },
        "tag.money.collector.label": {
          "y": 2165.5,
          "capCenterY": 2182
        },
        "talk.heading": {
          "y": 2284,
          "capCenterY": 2307.5
        },
        "talk.question": {
          "y": 2341,
          "capCenterY": 2395
        },
        "tag.talk.direct.label": {
          "y": 2502.5,
          "capCenterY": 2519
        },
        "tag.talk.diplomat.label": {
          "y": 2502.5,
          "capCenterY": 2519
        },
        "tag.talk.peaceful.label": {
          "y": 2502.5,
          "capCenterY": 2519
        },
        "tag.talk.debater.label": {
          "y": 2626.5,
          "capCenterY": 2643
        },
        "tag.talk.fiery.label": {
          "y": 2626.5,
          "capCenterY": 2643
        },
        "tag.talk.stubborn.label": {
          "y": 2626.5,
          "capCenterY": 2643
        },
        "tag.talk.logical.label": {
          "y": 2750.5,
          "capCenterY": 2767
        },
        "tag.talk.sarcastic.label": {
          "y": 2750.5,
          "capCenterY": 2767
        },
        "tag.talk.playful.label": {
          "y": 2750.5,
          "capCenterY": 2767
        },
        "tag.talk.quiet.label": {
          "y": 2874.5,
          "capCenterY": 2891
        },
        "tag.talk.chatty.label": {
          "y": 2874.5,
          "capCenterY": 2891
        },
        "sharing.heading": {
          "y": 2993,
          "capCenterY": 3016.5
        },
        "sharing.question": {
          "y": 3050,
          "capCenterY": 3104
        },
        "tag.sharing.open-book.label": {
          "y": 3211.5,
          "capCenterY": 3228
        },
        "tag.sharing.oversharer.label": {
          "y": 3211.5,
          "capCenterY": 3228
        },
        "tag.sharing.expressive.label": {
          "y": 3211.5,
          "capCenterY": 3228
        },
        "tag.sharing.trusting.label": {
          "y": 3335.5,
          "capCenterY": 3352
        },
        "tag.sharing.selective.label": {
          "y": 3335.5,
          "capCenterY": 3352
        },
        "tag.sharing.reserved.label": {
          "y": 3335.5,
          "capCenterY": 3352
        },
        "tag.sharing.shy.label": {
          "y": 3459.5,
          "capCenterY": 3476
        },
        "tag.sharing.private.label": {
          "y": 3459.5,
          "capCenterY": 3476
        },
        "tempo.heading": {
          "y": 3578,
          "capCenterY": 3601.5
        },
        "tempo.question": {
          "y": 3635,
          "capCenterY": 3689
        },
        "tag.tempo.planner.label": {
          "y": 3796.5,
          "capCenterY": 3813
        },
        "tag.tempo.steady.label": {
          "y": 3796.5,
          "capCenterY": 3813
        },
        "tag.tempo.driven.label": {
          "y": 3796.5,
          "capCenterY": 3813
        },
        "tag.tempo.adaptable.label": {
          "y": 3920.5,
          "capCenterY": 3937
        },
        "tag.tempo.laid-back.label": {
          "y": 3920.5,
          "capCenterY": 3937
        },
        "tag.tempo.free-spirit.label": {
          "y": 3920.5,
          "capCenterY": 3937
        },
        "tag.tempo.spontaneous.label": {
          "y": 4044.5,
          "capCenterY": 4061
        },
        "tag.tempo.last-minute.label": {
          "y": 4044.5,
          "capCenterY": 4061
        },
        "tag.tempo.impulsive.label": {
          "y": 4044.5,
          "capCenterY": 4061
        },
        "tag.tempo.night-owl.label": {
          "y": 4168.5,
          "capCenterY": 4185
        },
        "tag.tempo.early-bird.label": {
          "y": 4168.5,
          "capCenterY": 4185
        },
        "city.label": {
          "y": 461,
          "capCenterY": 488
        },
        "city.value": {
          "y": 563.5,
          "capCenterY": 587
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "placeholder": false,
          "color": "#ffffff"
        },
        "bio.count": {
          "text": "28 / 28",
          "color": "#ffb4c8"
        }
      },
      "hitOverrides": {
        "tag.role.performer": {
          "y": 404,
          "ariaInvalid": true
        },
        "tag.role.joker": {
          "y": 404,
          "ariaInvalid": true
        },
        "tag.role.storyteller": {
          "y": 404,
          "ariaInvalid": true
        },
        "tag.role.icebreaker": {
          "y": 528,
          "ariaInvalid": true
        },
        "tag.role.leader": {
          "y": 528,
          "ariaInvalid": true
        },
        "tag.role.motivator": {
          "y": 528,
          "ariaInvalid": true
        },
        "tag.role.sociable": {
          "y": 652,
          "ariaInvalid": true
        },
        "tag.role.team-player": {
          "y": 652,
          "ariaInvalid": true
        },
        "tag.role.caretaker": {
          "y": 652,
          "ariaInvalid": true
        },
        "tag.role.listener": {
          "y": 776,
          "ariaInvalid": true
        },
        "tag.role.observer": {
          "y": 776,
          "ariaInvalid": true
        },
        "tag.role.lone-wolf": {
          "y": 776,
          "ariaInvalid": true
        },
        "tag.role.rebel": {
          "y": 900,
          "ariaInvalid": true
        },
        "tag.experiences.daredevil": {
          "y": 1237,
          "ariaInvalid": true
        },
        "tag.experiences.competitive": {
          "y": 1237,
          "ariaInvalid": true
        },
        "tag.experiences.explorer": {
          "y": 1237,
          "ariaInvalid": true
        },
        "tag.experiences.curious": {
          "y": 1361,
          "ariaInvalid": true
        },
        "tag.experiences.dreamer": {
          "y": 1361,
          "ariaInvalid": true
        },
        "tag.experiences.skeptic": {
          "y": 1361,
          "ariaInvalid": true
        },
        "tag.experiences.overthinker": {
          "y": 1485,
          "ariaInvalid": true
        },
        "tag.experiences.cautious": {
          "y": 1485,
          "ariaInvalid": true
        },
        "tag.experiences.homebody": {
          "y": 1485,
          "ariaInvalid": true
        },
        "tag.money.saver": {
          "y": 1876,
          "ariaInvalid": true
        },
        "tag.money.thrifty": {
          "y": 1876,
          "ariaInvalid": true
        },
        "tag.money.spender": {
          "y": 1876,
          "ariaInvalid": true
        },
        "tag.money.generous": {
          "y": 2000,
          "ariaInvalid": true
        },
        "tag.money.investor": {
          "y": 2000,
          "ariaInvalid": true
        },
        "tag.money.minimalist": {
          "y": 2000,
          "ariaInvalid": true
        },
        "tag.money.deal-hunter": {
          "y": 2124,
          "ariaInvalid": true
        },
        "tag.money.collector": {
          "y": 2124,
          "ariaInvalid": true
        },
        "tag.talk.direct": {
          "y": 2461,
          "ariaInvalid": true
        },
        "tag.talk.diplomat": {
          "y": 2461,
          "ariaInvalid": true
        },
        "tag.talk.peaceful": {
          "y": 2461,
          "ariaInvalid": true
        },
        "tag.talk.debater": {
          "y": 2585,
          "ariaInvalid": true
        },
        "tag.talk.fiery": {
          "y": 2585,
          "ariaInvalid": true
        },
        "tag.talk.stubborn": {
          "y": 2585,
          "ariaInvalid": true
        },
        "tag.talk.logical": {
          "y": 2709,
          "ariaInvalid": true
        },
        "tag.talk.sarcastic": {
          "y": 2709,
          "ariaInvalid": true
        },
        "tag.talk.playful": {
          "y": 2709,
          "ariaInvalid": true
        },
        "tag.talk.quiet": {
          "y": 2833,
          "ariaInvalid": true
        },
        "tag.talk.chatty": {
          "y": 2833,
          "ariaInvalid": true
        },
        "tag.sharing.open-book": {
          "y": 3170,
          "ariaInvalid": true
        },
        "tag.sharing.oversharer": {
          "y": 3170,
          "ariaInvalid": true
        },
        "tag.sharing.expressive": {
          "y": 3170,
          "ariaInvalid": true
        },
        "tag.sharing.trusting": {
          "y": 3294,
          "ariaInvalid": true
        },
        "tag.sharing.selective": {
          "y": 3294,
          "ariaInvalid": true
        },
        "tag.sharing.reserved": {
          "y": 3294,
          "ariaInvalid": true
        },
        "tag.sharing.shy": {
          "y": 3418,
          "ariaInvalid": true
        },
        "tag.sharing.private": {
          "y": 3418,
          "ariaInvalid": true
        },
        "tag.tempo.planner": {
          "y": 3755,
          "ariaInvalid": true
        },
        "tag.tempo.steady": {
          "y": 3755,
          "ariaInvalid": true
        },
        "tag.tempo.driven": {
          "y": 3755,
          "ariaInvalid": true
        },
        "tag.tempo.adaptable": {
          "y": 3879,
          "ariaInvalid": true
        },
        "tag.tempo.laid-back": {
          "y": 3879,
          "ariaInvalid": true
        },
        "tag.tempo.free-spirit": {
          "y": 3879,
          "ariaInvalid": true
        },
        "tag.tempo.spontaneous": {
          "y": 4003,
          "ariaInvalid": true
        },
        "tag.tempo.last-minute": {
          "y": 4003,
          "ariaInvalid": true
        },
        "tag.tempo.impulsive": {
          "y": 4003,
          "ariaInvalid": true
        },
        "tag.tempo.night-owl": {
          "y": 4127,
          "ariaInvalid": true
        },
        "tag.tempo.early-bird": {
          "y": 4127,
          "ariaInvalid": true
        },
        "city": {
          "y": 529
        },
        "country": {
          "ariaInvalid": true
        },
        "bio": {
          "ariaInvalid": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {
        "about": {
          "h": 4299
        },
        "where": {
          "h": 701
        },
        "bio": {
          "h": 587
        }
      },
      "extraTexts": [
        {
          "id": "about.error",
          "parent": "about",
          "text": "Choose one answer in every topic.",
          "role": "error",
          "x": 53,
          "y": 193,
          "w": 729,
          "h": 47
        },
        {
          "id": "country.error",
          "parent": "where",
          "text": "Choose your country.",
          "role": "error",
          "x": 53,
          "y": 367,
          "w": 729,
          "h": 47
        },
        {
          "id": "bio.error",
          "parent": "bio",
          "text": "Keep your intro to two lines and 28 characters.",
          "lines": [
            "Keep your intro to two lines",
            "and 28 characters."
          ],
          "role": "error",
          "x": 53,
          "y": 430,
          "w": 729,
          "h": 94
        }
      ],
      "values": {
        "tags": {},
        "country": null,
        "city": "",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW"
      },
      "continue": {
        "enabled": false,
        "appearance": "existing-grey",
        "action": "explain-missing-fields",
        "proofBox": {
          "x": 195.5,
          "y": 7500.644,
          "w": 550,
          "h": 116
        }
      },
      "rejectedInput": {
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "behavior": "Reject the entire insertion with an explicit error, preserving the last valid draft. Do not silently clip a paste."
      },
      "note": "A 29-W replacement attempt is rejected with feedback; the existing 28-W draft stays intact. Oversize stored legacy bios must not be truncated or overwritten automatically; their migration policy requires the owner decision on the new limit.",
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4299
        },
        {
          "id": "where",
          "x": 53,
          "y": 6172.644,
          "w": 835,
          "h": 701
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6893.644,
          "w": 835,
          "h": 587
        }
      ],
      "contentHeight": 7697
    },
    "saving": {
      "elementOverrides": {
        "tag.role.team-player": {
          "piece": "pill.on"
        },
        "tag.experiences.competitive": {
          "piece": "pill.on"
        },
        "tag.money.deal-hunter": {
          "piece": "pill.on"
        },
        "tag.talk.stubborn": {
          "piece": "pill.on"
        },
        "tag.sharing.oversharer": {
          "piece": "pill.on"
        },
        "tag.tempo.spontaneous": {
          "piece": "pill.on"
        }
      },
      "textOverrides": {
        "tag.role.team-player.label": {
          "color": "#ffe36a"
        },
        "tag.experiences.competitive.label": {
          "color": "#ffe36a"
        },
        "tag.money.deal-hunter.label": {
          "color": "#ffe36a"
        },
        "tag.talk.stubborn.label": {
          "color": "#ffe36a"
        },
        "tag.sharing.oversharer.label": {
          "color": "#ffe36a"
        },
        "tag.tempo.spontaneous.label": {
          "color": "#ffe36a"
        },
        "country.value": {
          "text": "Spain",
          "lines": [
            "Spain"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "city.value": {
          "text": "Madrid",
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.count": {
          "text": "Saving…"
        }
      },
      "hitOverrides": {
        "tag.role.team-player": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.experiences.competitive": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.money.deal-hunter": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.talk.stubborn": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.sharing.oversharer": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.tempo.spontaneous": {
          "ariaChecked": true,
          "enabled": false
        },
        "tag.role.performer": {
          "enabled": false
        },
        "tag.role.joker": {
          "enabled": false
        },
        "tag.role.storyteller": {
          "enabled": false
        },
        "tag.role.icebreaker": {
          "enabled": false
        },
        "tag.role.leader": {
          "enabled": false
        },
        "tag.role.motivator": {
          "enabled": false
        },
        "tag.role.sociable": {
          "enabled": false
        },
        "tag.role.caretaker": {
          "enabled": false
        },
        "tag.role.listener": {
          "enabled": false
        },
        "tag.role.observer": {
          "enabled": false
        },
        "tag.role.lone-wolf": {
          "enabled": false
        },
        "tag.role.rebel": {
          "enabled": false
        },
        "tag.experiences.daredevil": {
          "enabled": false
        },
        "tag.experiences.explorer": {
          "enabled": false
        },
        "tag.experiences.curious": {
          "enabled": false
        },
        "tag.experiences.dreamer": {
          "enabled": false
        },
        "tag.experiences.skeptic": {
          "enabled": false
        },
        "tag.experiences.overthinker": {
          "enabled": false
        },
        "tag.experiences.cautious": {
          "enabled": false
        },
        "tag.experiences.homebody": {
          "enabled": false
        },
        "tag.money.saver": {
          "enabled": false
        },
        "tag.money.thrifty": {
          "enabled": false
        },
        "tag.money.spender": {
          "enabled": false
        },
        "tag.money.generous": {
          "enabled": false
        },
        "tag.money.investor": {
          "enabled": false
        },
        "tag.money.minimalist": {
          "enabled": false
        },
        "tag.money.collector": {
          "enabled": false
        },
        "tag.talk.direct": {
          "enabled": false
        },
        "tag.talk.diplomat": {
          "enabled": false
        },
        "tag.talk.peaceful": {
          "enabled": false
        },
        "tag.talk.debater": {
          "enabled": false
        },
        "tag.talk.fiery": {
          "enabled": false
        },
        "tag.talk.logical": {
          "enabled": false
        },
        "tag.talk.sarcastic": {
          "enabled": false
        },
        "tag.talk.playful": {
          "enabled": false
        },
        "tag.talk.quiet": {
          "enabled": false
        },
        "tag.talk.chatty": {
          "enabled": false
        },
        "tag.sharing.open-book": {
          "enabled": false
        },
        "tag.sharing.expressive": {
          "enabled": false
        },
        "tag.sharing.trusting": {
          "enabled": false
        },
        "tag.sharing.selective": {
          "enabled": false
        },
        "tag.sharing.reserved": {
          "enabled": false
        },
        "tag.sharing.shy": {
          "enabled": false
        },
        "tag.sharing.private": {
          "enabled": false
        },
        "tag.tempo.planner": {
          "enabled": false
        },
        "tag.tempo.steady": {
          "enabled": false
        },
        "tag.tempo.driven": {
          "enabled": false
        },
        "tag.tempo.adaptable": {
          "enabled": false
        },
        "tag.tempo.laid-back": {
          "enabled": false
        },
        "tag.tempo.free-spirit": {
          "enabled": false
        },
        "tag.tempo.last-minute": {
          "enabled": false
        },
        "tag.tempo.impulsive": {
          "enabled": false
        },
        "tag.tempo.night-owl": {
          "enabled": false
        },
        "tag.tempo.early-bird": {
          "enabled": false
        },
        "country": {
          "enabled": false
        },
        "city": {
          "enabled": false
        },
        "bio": {
          "enabled": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.team-player",
          "EXPERIENCES": "experiences.competitive",
          "MONEY": "money.deal-hunter",
          "TALK": "talk.stubborn",
          "SHARING": "sharing.oversharer",
          "TEMPO": "tempo.spontaneous"
        },
        "country": "ES",
        "city": "Madrid",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "existingFields": "valid review fixture",
        "busy": true
      },
      "continue": {
        "enabled": false,
        "appearance": "existing-grey",
        "action": null,
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "save_error": {
      "elementOverrides": {
        "tag.role.team-player": {
          "piece": "pill.on"
        },
        "tag.experiences.competitive": {
          "piece": "pill.on"
        },
        "tag.money.deal-hunter": {
          "piece": "pill.on"
        },
        "tag.talk.stubborn": {
          "piece": "pill.on"
        },
        "tag.sharing.oversharer": {
          "piece": "pill.on"
        },
        "tag.tempo.spontaneous": {
          "piece": "pill.on"
        }
      },
      "textOverrides": {
        "tag.role.team-player.label": {
          "color": "#ffe36a"
        },
        "tag.experiences.competitive.label": {
          "color": "#ffe36a"
        },
        "tag.money.deal-hunter.label": {
          "color": "#ffe36a"
        },
        "tag.talk.stubborn.label": {
          "color": "#ffe36a"
        },
        "tag.sharing.oversharer.label": {
          "color": "#ffe36a"
        },
        "tag.tempo.spontaneous.label": {
          "color": "#ffe36a"
        },
        "country.value": {
          "text": "Spain",
          "lines": [
            "Spain"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "city.value": {
          "text": "Madrid",
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.count": {
          "text": "28 / 28"
        }
      },
      "hitOverrides": {
        "tag.role.team-player": {
          "ariaChecked": true
        },
        "tag.experiences.competitive": {
          "ariaChecked": true
        },
        "tag.money.deal-hunter": {
          "ariaChecked": true
        },
        "tag.talk.stubborn": {
          "ariaChecked": true
        },
        "tag.sharing.oversharer": {
          "ariaChecked": true
        },
        "tag.tempo.spontaneous": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.team-player",
          "EXPERIENCES": "experiences.competitive",
          "MONEY": "money.deal-hunter",
          "TALK": "talk.stubborn",
          "SHARING": "sharing.oversharer",
          "TEMPO": "tempo.spontaneous"
        },
        "country": "ES",
        "city": "Madrid",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "existingFields": "valid review fixture"
      },
      "continue": {
        "enabled": true,
        "appearance": "existing-gold",
        "action": "save-current-profile",
        "message": "Could not save. Your changes are still here.",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "returning_incomplete": {
      "elementOverrides": {
        "tag.role.storyteller": {
          "piece": "pill.on"
        }
      },
      "textOverrides": {
        "tag.role.storyteller.label": {
          "color": "#ffe36a"
        }
      },
      "hitOverrides": {
        "tag.role.storyteller": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.storyteller"
        },
        "country": null,
        "city": "",
        "bio": ""
      },
      "continue": {
        "enabled": false,
        "appearance": "existing-grey",
        "action": "explain-missing-fields",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "note": "Existing stored fields and selected tags hydrate individually; missing tags remain empty. No random completion. Existing-player access/migration policy needs owner confirmation before a new global gate.",
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "focus_city": {
      "elementOverrides": {
        "tag.role.team-player": {
          "piece": "pill.on"
        },
        "tag.experiences.competitive": {
          "piece": "pill.on"
        },
        "tag.money.deal-hunter": {
          "piece": "pill.on"
        },
        "tag.talk.stubborn": {
          "piece": "pill.on"
        },
        "tag.sharing.oversharer": {
          "piece": "pill.on"
        },
        "tag.tempo.spontaneous": {
          "piece": "pill.on"
        },
        "city.field": {
          "piece": "field.focus"
        }
      },
      "textOverrides": {
        "tag.role.team-player.label": {
          "color": "#ffe36a"
        },
        "tag.experiences.competitive.label": {
          "color": "#ffe36a"
        },
        "tag.money.deal-hunter.label": {
          "color": "#ffe36a"
        },
        "tag.talk.stubborn.label": {
          "color": "#ffe36a"
        },
        "tag.sharing.oversharer.label": {
          "color": "#ffe36a"
        },
        "tag.tempo.spontaneous.label": {
          "color": "#ffe36a"
        },
        "country.value": {
          "text": "Spain",
          "lines": [
            "Spain"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "city.value": {
          "text": "Madrid",
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.count": {
          "text": "28 / 28"
        }
      },
      "hitOverrides": {
        "tag.role.team-player": {
          "ariaChecked": true
        },
        "tag.experiences.competitive": {
          "ariaChecked": true
        },
        "tag.money.deal-hunter": {
          "ariaChecked": true
        },
        "tag.talk.stubborn": {
          "ariaChecked": true
        },
        "tag.sharing.oversharer": {
          "ariaChecked": true
        },
        "tag.tempo.spontaneous": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.team-player",
          "EXPERIENCES": "experiences.competitive",
          "MONEY": "money.deal-hunter",
          "TALK": "talk.stubborn",
          "SHARING": "sharing.oversharer",
          "TEMPO": "tempo.spontaneous"
        },
        "country": "ES",
        "city": "Madrid",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "existingFields": "valid review fixture"
      },
      "continue": {
        "enabled": true,
        "appearance": "existing-gold",
        "action": "save-current-profile",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    },
    "focus_bio": {
      "elementOverrides": {
        "tag.role.team-player": {
          "piece": "pill.on"
        },
        "tag.experiences.competitive": {
          "piece": "pill.on"
        },
        "tag.money.deal-hunter": {
          "piece": "pill.on"
        },
        "tag.talk.stubborn": {
          "piece": "pill.on"
        },
        "tag.sharing.oversharer": {
          "piece": "pill.on"
        },
        "tag.tempo.spontaneous": {
          "piece": "pill.on"
        },
        "bio.field": {
          "piece": "field.focus"
        }
      },
      "textOverrides": {
        "tag.role.team-player.label": {
          "color": "#ffe36a"
        },
        "tag.experiences.competitive.label": {
          "color": "#ffe36a"
        },
        "tag.money.deal-hunter.label": {
          "color": "#ffe36a"
        },
        "tag.talk.stubborn.label": {
          "color": "#ffe36a"
        },
        "tag.sharing.oversharer.label": {
          "color": "#ffe36a"
        },
        "tag.tempo.spontaneous.label": {
          "color": "#ffe36a"
        },
        "country.value": {
          "text": "Spain",
          "lines": [
            "Spain"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "city.value": {
          "text": "Madrid",
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.value": {
          "text": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
          "lines": [
            "WWWWWWWWWWWWWW",
            "WWWWWWWWWWWWWW"
          ],
          "color": "#ffffff",
          "placeholder": false
        },
        "bio.count": {
          "text": "28 / 28"
        }
      },
      "hitOverrides": {
        "tag.role.team-player": {
          "ariaChecked": true
        },
        "tag.experiences.competitive": {
          "ariaChecked": true
        },
        "tag.money.deal-hunter": {
          "ariaChecked": true
        },
        "tag.talk.stubborn": {
          "ariaChecked": true
        },
        "tag.sharing.oversharer": {
          "ariaChecked": true
        },
        "tag.tempo.spontaneous": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "blockOverrides": {},
      "extraTexts": [],
      "values": {
        "tags": {
          "ROLE": "role.team-player",
          "EXPERIENCES": "experiences.competitive",
          "MONEY": "money.deal-hunter",
          "TALK": "talk.stubborn",
          "SHARING": "sharing.oversharer",
          "TEMPO": "tempo.spontaneous"
        },
        "country": "ES",
        "city": "Madrid",
        "bio": "WWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        "existingFields": "valid review fixture"
      },
      "continue": {
        "enabled": true,
        "appearance": "existing-gold",
        "action": "save-current-profile",
        "proofBox": {
          "x": 195.5,
          "y": 7249.644,
          "w": 550,
          "h": 116
        }
      },
      "flowProof": [
        {
          "id": "about",
          "x": 53,
          "y": 1853.644,
          "w": 835,
          "h": 4231
        },
        {
          "id": "where",
          "x": 53,
          "y": 6104.644,
          "w": 835,
          "h": 633
        },
        {
          "id": "bio",
          "x": 53,
          "y": 6757.644,
          "w": 835,
          "h": 472
        }
      ],
      "contentHeight": 7446
    }
  },
  "examples": [
    {
      "id": "empty",
      "state": "empty",
      "reviewFixture": true
    },
    {
      "id": "filled",
      "state": "filled",
      "reviewFixture": true
    },
    {
      "id": "invalid",
      "state": "invalid",
      "reviewFixture": true
    },
    {
      "id": "saving",
      "state": "saving",
      "reviewFixture": true
    },
    {
      "id": "save_error",
      "state": "save_error",
      "reviewFixture": true
    },
    {
      "id": "returning_incomplete",
      "state": "returning_incomplete",
      "reviewFixture": true
    },
    {
      "id": "focus_city",
      "state": "focus_city",
      "reviewFixture": true
    },
    {
      "id": "focus_bio",
      "state": "focus_bio",
      "reviewFixture": true
    }
  ],
  "assumptions": {
    "requiredNew": [
      "ROLE",
      "EXPERIENCES",
      "MONEY",
      "TALK",
      "SHARING",
      "TEMPO",
      "country"
    ],
    "optionalNew": [
      "city",
      "bio"
    ],
    "countryFlag": "No reserved flag box; owner decision open.",
    "bioLimit": {
      "proposed": 28,
      "ownerApproved": false,
      "reason": "14 W glyphs × 2 lines at Nunito 600/42, 673-unit lane; additionally validate rendered two-line fit."
    }
  },
  "notes": [
    "Reuse the three new block frames from the current Profile CSS actual source, ui4/panel-meetflirt@2x.png, not the unused --frame variable.",
    "The brief explicitly names field-v1 and field-focus-v1 for new fields. Current name field actually uses popup/slice/pill.large.v2.png; it stays as-is.",
    "One ABOUT YOU box keeps the six related questions together and avoids six repeated frames. Topic gaps and separate radio groups distinguish the questions.",
    "All initial selections are absent. Filled proofs are clearly documented review fixtures, never defaults.",
    "No new source graphics; preview PNGs are flattened review compositions, not application/background assets."
  ],
  "countryPicker": {
    "pattern": "apps/client/src/ui/LanguagePanel.tsx",
    "mode": "viewport overlay; only the list scrolls",
    "viewport": {
      "w": 941,
      "h": 1672
    },
    "frame": {
      "piece": "country.panel",
      "x": 51.5,
      "y": 344,
      "w": 838,
      "h": 984,
      "render": "border-image",
      "slicePx": {
        "top": 170,
        "right": 170,
        "bottom": 170,
        "left": 80
      },
      "borderWidth": {
        "top": 170,
        "right": 170,
        "bottom": 170,
        "left": 80
      }
    },
    "title": {
      "text": "Country",
      "x": 180,
      "y": 43,
      "w": 470,
      "h": 60,
      "font": "Nunito",
      "size": 48,
      "weight": 800
    },
    "close": {
      "x": 684,
      "y": 24,
      "w": 116,
      "h": 116,
      "action": "close-country-list",
      "ariaLabel": "Close country selection",
      "art": "One existing X is already in the reused Language panel; add no second X."
    },
    "list": {
      "x": 40,
      "y": 180,
      "w": 642,
      "h": 660,
      "rowW": 642,
      "rowH": 116,
      "rowPitch": 132,
      "columns": 1,
      "visibleRows": 5,
      "overflowY": "auto",
      "overscrollBehavior": "contain",
      "clip": true,
      "sort": "English country label",
      "currentCode": null,
      "selectedPiece": "country.row.on",
      "unselectedPiece": "country.row.off",
      "slicePx": {
        "top": 0,
        "right": 120,
        "bottom": 0,
        "left": 60
      },
      "label": {
        "x": 34,
        "w": 486,
        "size": 42,
        "weight": 600,
        "lineHeight": 47,
        "maxLines": 2
      },
      "reason": "One column fits long country names with live two-line labels; same Language panel/list/selected check pattern."
    },
    "rail": {
      "x": 736,
      "y": 180,
      "w": 24,
      "h": 660,
      "hit": {
        "x": 690,
        "y": 180,
        "w": 116,
        "h": 660
      },
      "trackPiece": "scroll.track",
      "thumbPiece": "scroll.thumb",
      "thumbMinH": 52,
      "capFormula": "renderedWidth * sourceTopSlice / sourceWidth"
    },
    "countries": [
      {
        "code": "AF",
        "name": "Afghanistan"
      },
      {
        "code": "AX",
        "name": "Åland Islands"
      },
      {
        "code": "AL",
        "name": "Albania"
      },
      {
        "code": "DZ",
        "name": "Algeria"
      },
      {
        "code": "AS",
        "name": "American Samoa"
      },
      {
        "code": "AD",
        "name": "Andorra"
      },
      {
        "code": "AO",
        "name": "Angola"
      },
      {
        "code": "AI",
        "name": "Anguilla"
      },
      {
        "code": "AQ",
        "name": "Antarctica"
      },
      {
        "code": "AG",
        "name": "Antigua and Barbuda"
      },
      {
        "code": "AR",
        "name": "Argentina"
      },
      {
        "code": "AM",
        "name": "Armenia"
      },
      {
        "code": "AW",
        "name": "Aruba"
      },
      {
        "code": "AU",
        "name": "Australia"
      },
      {
        "code": "AT",
        "name": "Austria"
      },
      {
        "code": "AZ",
        "name": "Azerbaijan"
      },
      {
        "code": "BS",
        "name": "Bahamas"
      },
      {
        "code": "BH",
        "name": "Bahrain"
      },
      {
        "code": "BD",
        "name": "Bangladesh"
      },
      {
        "code": "BB",
        "name": "Barbados"
      },
      {
        "code": "BY",
        "name": "Belarus"
      },
      {
        "code": "BE",
        "name": "Belgium"
      },
      {
        "code": "BZ",
        "name": "Belize"
      },
      {
        "code": "BJ",
        "name": "Benin"
      },
      {
        "code": "BM",
        "name": "Bermuda"
      },
      {
        "code": "BT",
        "name": "Bhutan"
      },
      {
        "code": "BO",
        "name": "Bolivia"
      },
      {
        "code": "BA",
        "name": "Bosnia and Herzegovina"
      },
      {
        "code": "BW",
        "name": "Botswana"
      },
      {
        "code": "BV",
        "name": "Bouvet Island"
      },
      {
        "code": "BR",
        "name": "Brazil"
      },
      {
        "code": "IO",
        "name": "British Indian Ocean Territory"
      },
      {
        "code": "VG",
        "name": "British Virgin Islands"
      },
      {
        "code": "BN",
        "name": "Brunei"
      },
      {
        "code": "BG",
        "name": "Bulgaria"
      },
      {
        "code": "BF",
        "name": "Burkina Faso"
      },
      {
        "code": "BI",
        "name": "Burundi"
      },
      {
        "code": "KH",
        "name": "Cambodia"
      },
      {
        "code": "CM",
        "name": "Cameroon"
      },
      {
        "code": "CA",
        "name": "Canada"
      },
      {
        "code": "CV",
        "name": "Cape Verde"
      },
      {
        "code": "BQ",
        "name": "Caribbean Netherlands"
      },
      {
        "code": "KY",
        "name": "Cayman Islands"
      },
      {
        "code": "CF",
        "name": "Central African Republic"
      },
      {
        "code": "TD",
        "name": "Chad"
      },
      {
        "code": "CL",
        "name": "Chile"
      },
      {
        "code": "CN",
        "name": "China"
      },
      {
        "code": "CX",
        "name": "Christmas Island"
      },
      {
        "code": "CC",
        "name": "Cocos (Keeling) Islands"
      },
      {
        "code": "CO",
        "name": "Colombia"
      },
      {
        "code": "KM",
        "name": "Comoros"
      },
      {
        "code": "CK",
        "name": "Cook Islands"
      },
      {
        "code": "CR",
        "name": "Costa Rica"
      },
      {
        "code": "CI",
        "name": "Côte d'Ivoire (Ivory Coast)"
      },
      {
        "code": "HR",
        "name": "Croatia"
      },
      {
        "code": "CU",
        "name": "Cuba"
      },
      {
        "code": "CW",
        "name": "Curaçao"
      },
      {
        "code": "CY",
        "name": "Cyprus"
      },
      {
        "code": "CZ",
        "name": "Czechia"
      },
      {
        "code": "DK",
        "name": "Denmark"
      },
      {
        "code": "DJ",
        "name": "Djibouti"
      },
      {
        "code": "DM",
        "name": "Dominica"
      },
      {
        "code": "DO",
        "name": "Dominican Republic"
      },
      {
        "code": "CD",
        "name": "DR Congo"
      },
      {
        "code": "EC",
        "name": "Ecuador"
      },
      {
        "code": "EG",
        "name": "Egypt"
      },
      {
        "code": "SV",
        "name": "El Salvador"
      },
      {
        "code": "GQ",
        "name": "Equatorial Guinea"
      },
      {
        "code": "ER",
        "name": "Eritrea"
      },
      {
        "code": "EE",
        "name": "Estonia"
      },
      {
        "code": "SZ",
        "name": "Eswatini (Swaziland)"
      },
      {
        "code": "ET",
        "name": "Ethiopia"
      },
      {
        "code": "EU",
        "name": "European Union"
      },
      {
        "code": "FK",
        "name": "Falkland Islands"
      },
      {
        "code": "FO",
        "name": "Faroe Islands"
      },
      {
        "code": "FJ",
        "name": "Fiji"
      },
      {
        "code": "FI",
        "name": "Finland"
      },
      {
        "code": "FR",
        "name": "France"
      },
      {
        "code": "GF",
        "name": "French Guiana"
      },
      {
        "code": "PF",
        "name": "French Polynesia"
      },
      {
        "code": "TF",
        "name": "French Southern and Antarctic Lands"
      },
      {
        "code": "GA",
        "name": "Gabon"
      },
      {
        "code": "GM",
        "name": "Gambia"
      },
      {
        "code": "GE",
        "name": "Georgia"
      },
      {
        "code": "DE",
        "name": "Germany"
      },
      {
        "code": "GH",
        "name": "Ghana"
      },
      {
        "code": "GI",
        "name": "Gibraltar"
      },
      {
        "code": "GR",
        "name": "Greece"
      },
      {
        "code": "GL",
        "name": "Greenland"
      },
      {
        "code": "GD",
        "name": "Grenada"
      },
      {
        "code": "GP",
        "name": "Guadeloupe"
      },
      {
        "code": "GU",
        "name": "Guam"
      },
      {
        "code": "GT",
        "name": "Guatemala"
      },
      {
        "code": "GG",
        "name": "Guernsey"
      },
      {
        "code": "GN",
        "name": "Guinea"
      },
      {
        "code": "GW",
        "name": "Guinea-Bissau"
      },
      {
        "code": "GY",
        "name": "Guyana"
      },
      {
        "code": "HT",
        "name": "Haiti"
      },
      {
        "code": "HM",
        "name": "Heard Island and McDonald Islands"
      },
      {
        "code": "HN",
        "name": "Honduras"
      },
      {
        "code": "HK",
        "name": "Hong Kong"
      },
      {
        "code": "HU",
        "name": "Hungary"
      },
      {
        "code": "IS",
        "name": "Iceland"
      },
      {
        "code": "IN",
        "name": "India"
      },
      {
        "code": "ID",
        "name": "Indonesia"
      },
      {
        "code": "IR",
        "name": "Iran"
      },
      {
        "code": "IQ",
        "name": "Iraq"
      },
      {
        "code": "IE",
        "name": "Ireland"
      },
      {
        "code": "IM",
        "name": "Isle of Man"
      },
      {
        "code": "IL",
        "name": "Israel"
      },
      {
        "code": "IT",
        "name": "Italy"
      },
      {
        "code": "JM",
        "name": "Jamaica"
      },
      {
        "code": "JP",
        "name": "Japan"
      },
      {
        "code": "JE",
        "name": "Jersey"
      },
      {
        "code": "JO",
        "name": "Jordan"
      },
      {
        "code": "KZ",
        "name": "Kazakhstan"
      },
      {
        "code": "KE",
        "name": "Kenya"
      },
      {
        "code": "KI",
        "name": "Kiribati"
      },
      {
        "code": "XK",
        "name": "Kosovo"
      },
      {
        "code": "KW",
        "name": "Kuwait"
      },
      {
        "code": "KG",
        "name": "Kyrgyzstan"
      },
      {
        "code": "LA",
        "name": "Laos"
      },
      {
        "code": "LV",
        "name": "Latvia"
      },
      {
        "code": "LB",
        "name": "Lebanon"
      },
      {
        "code": "LS",
        "name": "Lesotho"
      },
      {
        "code": "LR",
        "name": "Liberia"
      },
      {
        "code": "LY",
        "name": "Libya"
      },
      {
        "code": "LI",
        "name": "Liechtenstein"
      },
      {
        "code": "LT",
        "name": "Lithuania"
      },
      {
        "code": "LU",
        "name": "Luxembourg"
      },
      {
        "code": "MO",
        "name": "Macau"
      },
      {
        "code": "MG",
        "name": "Madagascar"
      },
      {
        "code": "MW",
        "name": "Malawi"
      },
      {
        "code": "MY",
        "name": "Malaysia"
      },
      {
        "code": "MV",
        "name": "Maldives"
      },
      {
        "code": "ML",
        "name": "Mali"
      },
      {
        "code": "MT",
        "name": "Malta"
      },
      {
        "code": "MH",
        "name": "Marshall Islands"
      },
      {
        "code": "MQ",
        "name": "Martinique"
      },
      {
        "code": "MR",
        "name": "Mauritania"
      },
      {
        "code": "MU",
        "name": "Mauritius"
      },
      {
        "code": "YT",
        "name": "Mayotte"
      },
      {
        "code": "MX",
        "name": "Mexico"
      },
      {
        "code": "FM",
        "name": "Micronesia"
      },
      {
        "code": "MD",
        "name": "Moldova"
      },
      {
        "code": "MC",
        "name": "Monaco"
      },
      {
        "code": "MN",
        "name": "Mongolia"
      },
      {
        "code": "ME",
        "name": "Montenegro"
      },
      {
        "code": "MS",
        "name": "Montserrat"
      },
      {
        "code": "MA",
        "name": "Morocco"
      },
      {
        "code": "MZ",
        "name": "Mozambique"
      },
      {
        "code": "MM",
        "name": "Myanmar"
      },
      {
        "code": "NA",
        "name": "Namibia"
      },
      {
        "code": "NR",
        "name": "Nauru"
      },
      {
        "code": "NP",
        "name": "Nepal"
      },
      {
        "code": "NL",
        "name": "Netherlands"
      },
      {
        "code": "NC",
        "name": "New Caledonia"
      },
      {
        "code": "NZ",
        "name": "New Zealand"
      },
      {
        "code": "NI",
        "name": "Nicaragua"
      },
      {
        "code": "NE",
        "name": "Niger"
      },
      {
        "code": "NG",
        "name": "Nigeria"
      },
      {
        "code": "NU",
        "name": "Niue"
      },
      {
        "code": "NF",
        "name": "Norfolk Island"
      },
      {
        "code": "KP",
        "name": "North Korea"
      },
      {
        "code": "MK",
        "name": "North Macedonia"
      },
      {
        "code": "MP",
        "name": "Northern Mariana Islands"
      },
      {
        "code": "NO",
        "name": "Norway"
      },
      {
        "code": "OM",
        "name": "Oman"
      },
      {
        "code": "PK",
        "name": "Pakistan"
      },
      {
        "code": "PW",
        "name": "Palau"
      },
      {
        "code": "PS",
        "name": "Palestine"
      },
      {
        "code": "PA",
        "name": "Panama"
      },
      {
        "code": "PG",
        "name": "Papua New Guinea"
      },
      {
        "code": "PY",
        "name": "Paraguay"
      },
      {
        "code": "PE",
        "name": "Peru"
      },
      {
        "code": "PH",
        "name": "Philippines"
      },
      {
        "code": "PN",
        "name": "Pitcairn Islands"
      },
      {
        "code": "PL",
        "name": "Poland"
      },
      {
        "code": "PT",
        "name": "Portugal"
      },
      {
        "code": "PR",
        "name": "Puerto Rico"
      },
      {
        "code": "QA",
        "name": "Qatar"
      },
      {
        "code": "CG",
        "name": "Republic of the Congo"
      },
      {
        "code": "RE",
        "name": "Réunion"
      },
      {
        "code": "RO",
        "name": "Romania"
      },
      {
        "code": "RU",
        "name": "Russia"
      },
      {
        "code": "RW",
        "name": "Rwanda"
      },
      {
        "code": "BL",
        "name": "Saint Barthélemy"
      },
      {
        "code": "SH",
        "name": "Saint Helena, Ascension and Tristan da Cunha"
      },
      {
        "code": "KN",
        "name": "Saint Kitts and Nevis"
      },
      {
        "code": "LC",
        "name": "Saint Lucia"
      },
      {
        "code": "MF",
        "name": "Saint Martin"
      },
      {
        "code": "PM",
        "name": "Saint Pierre and Miquelon"
      },
      {
        "code": "VC",
        "name": "Saint Vincent and the Grenadines"
      },
      {
        "code": "WS",
        "name": "Samoa"
      },
      {
        "code": "SM",
        "name": "San Marino"
      },
      {
        "code": "ST",
        "name": "São Tomé and Príncipe"
      },
      {
        "code": "SA",
        "name": "Saudi Arabia"
      },
      {
        "code": "SN",
        "name": "Senegal"
      },
      {
        "code": "RS",
        "name": "Serbia"
      },
      {
        "code": "SC",
        "name": "Seychelles"
      },
      {
        "code": "SL",
        "name": "Sierra Leone"
      },
      {
        "code": "SG",
        "name": "Singapore"
      },
      {
        "code": "SX",
        "name": "Sint Maarten"
      },
      {
        "code": "SK",
        "name": "Slovakia"
      },
      {
        "code": "SI",
        "name": "Slovenia"
      },
      {
        "code": "SB",
        "name": "Solomon Islands"
      },
      {
        "code": "SO",
        "name": "Somalia"
      },
      {
        "code": "ZA",
        "name": "South Africa"
      },
      {
        "code": "GS",
        "name": "South Georgia"
      },
      {
        "code": "KR",
        "name": "South Korea"
      },
      {
        "code": "SS",
        "name": "South Sudan"
      },
      {
        "code": "ES",
        "name": "Spain"
      },
      {
        "code": "LK",
        "name": "Sri Lanka"
      },
      {
        "code": "SD",
        "name": "Sudan"
      },
      {
        "code": "SR",
        "name": "Suriname"
      },
      {
        "code": "SJ",
        "name": "Svalbard and Jan Mayen"
      },
      {
        "code": "SE",
        "name": "Sweden"
      },
      {
        "code": "CH",
        "name": "Switzerland"
      },
      {
        "code": "SY",
        "name": "Syria"
      },
      {
        "code": "TW",
        "name": "Taiwan"
      },
      {
        "code": "TJ",
        "name": "Tajikistan"
      },
      {
        "code": "TZ",
        "name": "Tanzania"
      },
      {
        "code": "TH",
        "name": "Thailand"
      },
      {
        "code": "TL",
        "name": "Timor-Leste"
      },
      {
        "code": "TG",
        "name": "Togo"
      },
      {
        "code": "TK",
        "name": "Tokelau"
      },
      {
        "code": "TO",
        "name": "Tonga"
      },
      {
        "code": "TT",
        "name": "Trinidad and Tobago"
      },
      {
        "code": "TN",
        "name": "Tunisia"
      },
      {
        "code": "TR",
        "name": "Turkey"
      },
      {
        "code": "TM",
        "name": "Turkmenistan"
      },
      {
        "code": "TC",
        "name": "Turks and Caicos Islands"
      },
      {
        "code": "TV",
        "name": "Tuvalu"
      },
      {
        "code": "UG",
        "name": "Uganda"
      },
      {
        "code": "UA",
        "name": "Ukraine"
      },
      {
        "code": "AE",
        "name": "United Arab Emirates"
      },
      {
        "code": "GB",
        "name": "United Kingdom"
      },
      {
        "code": "UN",
        "name": "United Nations"
      },
      {
        "code": "US",
        "name": "United States"
      },
      {
        "code": "UM",
        "name": "United States Minor Outlying Islands"
      },
      {
        "code": "VI",
        "name": "United States Virgin Islands"
      },
      {
        "code": "UY",
        "name": "Uruguay"
      },
      {
        "code": "UZ",
        "name": "Uzbekistan"
      },
      {
        "code": "VU",
        "name": "Vanuatu"
      },
      {
        "code": "VA",
        "name": "Vatican City (Holy See)"
      },
      {
        "code": "VE",
        "name": "Venezuela"
      },
      {
        "code": "VN",
        "name": "Vietnam"
      },
      {
        "code": "WF",
        "name": "Wallis and Futuna"
      },
      {
        "code": "EH",
        "name": "Western Sahara"
      },
      {
        "code": "YE",
        "name": "Yemen"
      },
      {
        "code": "ZM",
        "name": "Zambia"
      },
      {
        "code": "ZW",
        "name": "Zimbabwe"
      }
    ],
    "flags": false,
    "commit": "A row sets the explicit country code and closes; restore focus to Country. Closing without choosing leaves the draft unchanged.",
    "pageScroll": "Freeze and restore the underlying form scroll offset. Popup stays in 941 × 1672 viewport space, not full document space.",
    "longLabels": "Use a second line; all existing catalog country names are measured. No flag placeholders, no IP/room-derived default."
  },
  "dataContract": {
    "identity": "Existing principal.id / current Prio1-linked session; no new identity.",
    "read": "GET /api/me: principal plus card from Cards.own(id)",
    "write": "PATCH /api/me via existing updateMe; server Cards validates tags/country/city/bio. No write performed by this delivery.",
    "fields": {
      "displayName": "principal.displayName, existing profile input (1–8 characters); never avatar label",
      "age": "principal.birthDate -> ageYears; ageBand alone cannot yield an exact age. Keep the existing DOB collection; never publish DOB.",
      "gender": "principal.identity, explicit woman/man/other; legacy genderOf mapping; never avatar filter",
      "country": "card_profiles.country from explicit user code; label via COUNTRY_NAMES. Current map contains non-country entries such as EU/UN; list approval needs owner review.",
      "city": "card_profiles.city, optional 40; empty stays absent",
      "tags": "player_tags(topic,tag_id) -> tag_catalog; permanent IDs from packages/protocol/src/f6.ts",
      "bio": "card_profiles.bio, user-written optional; current server BIO_MAX=160 is provisional and differs from measured proposal 28",
      "avatars": "principal.avatarId -> public/avatars/manifest.json; same selected ID for all expressions",
      "canMessage": "Cards.canMessage(viewerId,targetId), server viewer-specific relation"
    },
    "draft": "Keep drafts when switching country picker, revisiting, or save fails; do not claim persisted until server success. Hydrate existing partial data without fabricating answers.",
    "continueRule": "Design assumption: existing profileComplete plus one valid tag per topic plus a valid explicitly selected country; city/bio may be blank. On saving, prevent duplicate submits. Grey incomplete CTA retains its existing explain-why behavior.",
    "ownPreview": "Selected gold words and the bio edit preview expose the current choices in this form. Existing player-card proof is a separate contract; do not generate or bake a new card into this page.",
    "implementationStatus": "No application, service, persistence, migration, or deployment work in this design delivery."
  },
  "verification": {
    "status": "PASS for offline geometry, catalog, raster word fit and source integrity",
    "browserTest": false,
    "browserUnavailable": "Chromium exits in this sandbox: sandbox_host_linux.cc shutdown Operation not permitted. Proofs use actual WOFF2 FreeType/HarfBuzz + Sharp raster composition.",
    "textFloor": {
      "chipCssPx360": 9.946865037194474,
      "chipPass": false,
      "reason": "BRIEF-PROFILE explicitly fixes CREATE ROOM chip font to 26; preserved. No general 16 CSS px claim.",
      "newFieldsCssPx360": 16.068012752391073,
      "newCaptionsCssPx360": 14.155154091392136
    },
    "bio": {
      "font": "Nunito 600",
      "size": 42,
      "lineHeight": 47,
      "laneW": 673,
      "lines": 2,
      "wAdvance": 46.494,
      "fourteenW": 650.916,
      "fifteenW": 697.4100000000001,
      "proposedLimit": 28,
      "ownerApproved": false,
      "asciiWidest": {
        "text": "W",
        "size": 42,
        "weight": 600,
        "advance": 46.494,
        "ink": [
          1.554,
          -0.29400000000000004,
          45.024,
          29.904000000000003
        ]
      }
    },
    "all60": [
      {
        "topic": "ROLE",
        "count": 13,
        "widest": {
          "word": "Team player",
          "advance": 147.96599999999998
        },
        "minimumControlW": 198,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      },
      {
        "topic": "EXPERIENCES",
        "count": 9,
        "widest": {
          "word": "Competitive",
          "advance": 145.626
        },
        "minimumControlW": 196,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      },
      {
        "topic": "MONEY",
        "count": 8,
        "widest": {
          "word": "Deal hunter",
          "advance": 143.078
        },
        "minimumControlW": 194,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      },
      {
        "topic": "TALK",
        "count": 11,
        "widest": {
          "word": "Stubborn",
          "advance": 112.892
        },
        "minimumControlW": 163,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      },
      {
        "topic": "SHARING",
        "count": 8,
        "widest": {
          "word": "Oversharer",
          "advance": 134.394
        },
        "minimumControlW": 185,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      },
      {
        "topic": "TEMPO",
        "count": 11,
        "widest": {
          "word": "Spontaneous",
          "advance": 158.418
        },
        "minimumControlW": 209,
        "actualControlW": 228,
        "columns": 3,
        "rowPitch": 124
      }
    ],
    "report": "evidence/verification.json",
    "wordFit": {
      "samples": 120,
      "minimumGap": 26.99471428571428,
      "allAtLeast16": true
    },
    "targetOverlaps": 0,
    "textInkOverlaps": 0,
    "proofs": [
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-add.png",
        "width": 941,
        "height": 7446,
        "sha256": "a3c610bbf92d5efa1c7481651c72b698eb749461bf58c0f8dded261fecf35ddd"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-add-360.png",
        "width": 360,
        "height": 2849,
        "sha256": "49fda0b0b768fbc12c0f382385e5dd96912df9323b0fe69cd47d16f5d7e3134e"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-filled.png",
        "width": 941,
        "height": 7446,
        "sha256": "2592555c369978dd9bb02991991eb2d8fa7f35be53fa0df015125c816de1bebb"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-filled-360.png",
        "width": 360,
        "height": 2849,
        "sha256": "ffe689a58c9df39523deca51b1d478e67f93a046235995cb5ec8c550837ccc4a"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-invalid.png",
        "width": 941,
        "height": 7697,
        "sha256": "b827e51b7eb6bcc5cf82f0ffe3d9499d62f14344aa43c1894ca6667e6fa91bea"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-invalid-360.png",
        "width": 360,
        "height": 2945,
        "sha256": "401b05d3d87e3f72d7b5a33b7ab4b2dcf2d08c8c513984e7048a69fbb0d4fb8e"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-saving-360.png",
        "width": 360,
        "height": 2849,
        "sha256": "e9bac8c3af440a387dc341201adebd79d40cda4f8f872652017df3b4380cf7dc"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-country-open.png",
        "width": 941,
        "height": 1672,
        "sha256": "3f58ed7abb19260e3434e15df8df10ea043ddf61d4ec3a391ee8fb09953e8752"
      },
      {
        "path": "art/src/player-card-2026-10-07/profile/preview/PROFILE-country-open-360.png",
        "width": 360,
        "height": 640,
        "sha256": "d52bbf1f7f7dcb7df633a4c55abfaae54af24c1181d23caccbd0693bca21ce55"
      }
    ]
  },
  "contentHeight": 7446,
  "scroll": {
    "type": "form",
    "onlyIfNeeded": true,
    "scaleBase": {
      "w": 941,
      "h": 1672
    },
    "background": "Existing profile-cut/background.png, object-fit:cover, object-position:50% 0 across the flow height, exactly as current app.css. Taller content changes the scenic crop; no new scene or attached UI."
  }
}
